(function() {
	'use strict';

	var ripsawModule = angular.module('ripsaw', []);

	var widgetModule = angular.module('ripsaw.widgets', [
		'ripsaw',
		'mgcrea.ngStrap',
		'ngSanitize'
	]);

	ripsawModule.constant('TIME_ZONES', {
		version : '2016i-09/2017',
		zones : [
			'Pacific/Midway|LMT NST BST SST|bm.M b0 b0 b0|0123|-2nDMB.c 2gVzB.c EyM0|37e2',
			'Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4',
			'America/Anchorage|CAT CAWT CAPT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4',
			'America/Argentina/Buenos_Aires|CMT ART ARST ART ARST|4g.M 40 30 30 20|0121212121212121212121212121212121212121213434343434343234343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 j3c0 uL0 1qN0 WL0',
			'America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6',
			'America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5',
			'America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5',
			'America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5',
			'America/Rio_Branco|LMT ACT ACST AMT|4v.c 50 40 40|01212121212121212121212121212131|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4',
			'America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6',
			'America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5',
			'Canada/Atlantic|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4',
			'America/La_Paz|CMT BOST BOT|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5',
			'Canada/Newfoundland|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4',
			'America/Montevideo|MMT UYT UYHST UYST UYT UYHST|3I.I 3u 30 20 30 2u|012121212121212121212121213434343434345454543453434343434343434343434343434343434343434|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5',
			'America/Noronha|LMT FNT FNST|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2',
			'Atlantic/Azores|HMT AZOT AZOST AZOMT AZOT AZOST WET|1S.w 20 10 0 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545456545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4',
			'Atlantic/Cape_Verde|LMT CVT CVST CVT|1y.4 20 10 10|01213|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4',
			'Atlantic/Reykjavik|LMT IST ISST GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4',
			'Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6',
			'Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5',
			'Africa/Bangui|LMT WAT|-d.A -10|01|-22y0d.A|17e6',
			'Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5',
			'Africa/Harare|LMT CAT|-2a.k -20|01|-2GJea.k|26e5',
			'Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6',
			'Africa/Nairobi|LMT EAT BEAT BEAUT|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5',
			'Asia/Tehran|LMT TMT IRST IRST IRDT IRDT|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6',
			'Asia/Muscat|LMT GST|-3F.c -40|01|-21JfF.c|39e5',
			'Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5',
			'Asia/Kabul|AFT AFT|-40 -4u|01|-10Qs0|46e5',
			'Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5',
			'Asia/Karachi|LMT IST IST KART PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6',
			'Asia/Calcutta|HMT BURT IST IST|-5R.k -6u -5u -6u|01232|-18LFR.k 1unn.k HB0 7zX0|15e6',
			'Asia/Kathmandu|LMT IST NPT|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5',
			'Asia/Dhaka|HMT BURT IST DACT BDT BDST|-5R.k -6u -5u -60 -60 -70|01213454|-18LFR.k 1unn.k HB0 m6n0 LqMu 1x6n0 1i00|16e6',
			'Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5',
			'Asia/Rangoon|RMT BURT JST MMT|-6o.E -6u -90 -6u|0123|-21Jio.E SmnS.E 7j9u|48e5',
			'Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5',
			'Asia/Bangkok|BMT ICT|-6G.4 -70|01|-218SG.4|15e6',
			'Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5',
			'Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4',
			'Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4',
			'Asia/Seoul|LMT KST JCST JST KST KDT KDT|-8r.Q -8u -90 -90 -90 -9u -a0|01234151515151515146464|-2um8r.Q 97XV.Q 12FXu jjA0 kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6',
			'Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4',
			'Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5',
			'Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5',
			'Australia/Canberra|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5',
			'Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3',
			'Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5',
			'Pacific/Fiji|LMT FJT FJST|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|88e4',
			'Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121212121212121212121212121212121212121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|75e3',
			'Pacific/Kwajalein|MHT KWAT MHT|-b0 c0 -c0|012|-AX0 W9X0|14e3',
			'America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3',
			'America/Caracas|CMT VET VET|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5',
			'America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4',
			'Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6',
			'Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5',
			'Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5',
			'Asia/Singapore|SMT MALT MALST MALT MALT JST SGT SGT|-6T.p -70 -7k -7k -7u -90 -7u -80|012345467|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu Mspu DTA0|56e5',
			'Asia/Tokyo|JCST JST JDT|-90 -90 -a0|0121212121|-1iw90 pKq0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6',
			'Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4',
			'Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4',
			'Pacific/Pago_Pago|LMT NST BST SST|bm.M b0 b0 b0|0123|-2nDMB.c 2gVzB.c EyM0|37e2',
			'America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4',
			'GMT|GMT|0|0|'
		],
		links : [
			'America/Toronto|Canada/Eastern',
			'America/Toronto|Canada/East',
			'America/Argentina/Buenos_Aires|America/Argentina',
			'Pacific/Pago_Pago|Pacific/Samoa',
			'America/Regina|Canada/East-Saskatchewan'
		]
	});

	widgetModule.config([
		'$compileProvider',
		'$provide',
		'$controllerProvider',
		'$filterProvider',
		'$injector',
		function($compileProvider, $provide, $controllerProvider, $filterProvider, $injector) {
			var transmute = function(target) {

				function getConstructorFunc(factory)
				{
					if (typeof factory === 'function')
					{
						return factory;
					}

					if (window.jQuery.isArray(factory) && factory.length > 0)
					{
						return factory.slice(-1)[0];
					}

					return null;
				}

				function annotate(factory)
				{
					if (window.jQuery.isArray && !window.jQuery.isArray(factory))
					{
						var annotations = $injector.annotate(factory),
							constructor = getConstructorFunc(factory);

						if (constructor)
						{
							factory = annotations.concat(constructor);
						}
					}
					return factory;
				}

				function getTransmuter(dependency)
				{
					if (dependency === '$http')
					{
						return function(name, factory)
						{
							var index = factory.indexOf('$http'),
								constructor = getConstructorFunc(factory),
								transmutedFactory = factory.slice(0, -1);

							transmutedFactory[index] = '_rsProxy';

							transmutedFactory.push(function() {

								var ProxyFactory = arguments[index],
									proxy = new ProxyFactory(name),
									args = [];

								for (var i = 0; i < arguments.length; ++i)
								{
									args.push(arguments[i]);
								}
								args[index] = proxy;

								return constructor.apply(this, args);

							});

							return transmutedFactory;
						};
					}

					return undefined;
				}

				return function registerTransmutedTarget(name, factory)
				{
					// transmute dependencies
					var annotatedFactory = annotate(factory);
					if (annotatedFactory)
					{
						for (var i = 0; i < annotatedFactory.length - 1; ++i)
						{
							var transmuter = getTransmuter(annotatedFactory[i]);
							if (transmuter)
							{
								annotatedFactory = transmuter(name, annotatedFactory);
							}
						}

						factory = annotatedFactory;
					}

					// register on the target
					return target(name, factory);
				};

			};

			widgetModule.controller = transmute($controllerProvider.register);
			widgetModule.directive = transmute($compileProvider.directive);
			widgetModule.filter = transmute($filterProvider.register);
			widgetModule.factory = transmute($provide.factory);
			widgetModule.service = transmute($provide.service);
			widgetModule.value = $provide.value;
			widgetModule.constant = $provide.constant;
		}
	]);

	ripsawModule.config([
		'TIME_ZONES',
		function(TIME_ZONES) {

			moment.tz.load(TIME_ZONES);

			if (!Array.prototype.indexOf) {
				Array.prototype.indexOf = function(
					searchElement, fromIndex) {
					var k;
					if (this === null) {
						throw new TypeError(
							'"this" is null or not defined'
						);
					}

					var O = Object(this);
					var len = O.length;
					if (len === 0) {
						return -1;
					}

					var n = +fromIndex || 0;
					if (Math.abs(n) === Infinity) {
						n = 0;
					}

					if (n >= len) {
						return -1;
					}

					k = Math.max(n >= 0 ? n : len -
						Math.abs(n), 0);

					while (k < len) {
						if (k in O && O[k] ===
							searchElement) {
							return k;
						}
						k++;
					}
					return -1;
				};
				return true;
			} else {
				return false;
			}
		}
	]);
})();

(function(module) {
	'use strict';

	/**
	 * Sets the application specific routes to services used by ripsaw client.
	 * The init function should be run in the config stage of the application.
	 */
	module.provider('rsConfig', [
		'routeTypes',
		function(routeTypes) {

			var routes;

			// default to public endpoints if not specified by product
			var DEFAULTS = {};
			DEFAULTS[routeTypes.PERMISSIONS] = '/roleservice/v2';
			DEFAULTS[routeTypes.REGISTRY] = '/widget-registry/v2';

			/**
			 * Initializes routes
			 *
			 * @param {Object} appRoutes - map of route type -> route
			 */
			function init(appRoutes) {
				routes = _.extend({}, DEFAULTS, appRoutes);
			}

			function $get() {
				if (!routes) {
					throw new Error('"init" method was not called first');
				}

				return {
					/**
					 * Fetches configured route
					 *
					 * @param {String} key - route key to fetch
					 * @returns {String} - configured route
					 */
					getRoute: function(key) {
						var route = routes[key];
						if (!route) {
							throw new Error('Route: ' + key + ' was not configured');
						}
						return route;
					}
				};
			}

			return {
				init: init,
				$get: $get
			};
		}
	]);
})(angular.module('ripsaw'));

(function () {
	'use strict';
	angular.module('ripsaw')
		.factory('rsBenchmarks', [
			'httpCache',
			'rsConfig',
			'routeTypes',
			'_rsTranslations',
			function (httpCache, rsConfig, routeTypes, rsTranslations) {
				var PERCENTILE = 'percentile';
				var DYNAMIC_COMPARISON = 'dynamic-comparison';

				function getBenchmarkServiceURL(fieldSetId) {
					return rsConfig.getRoute(routeTypes.BENCHMARKS) + '/fieldsets/' + fieldSetId + '/sources';
				}

				function getBenchmarkBody(fieldSetId, sourceName, fields, metric, benchmarkType) {
					var DEFAULT_NAME = '';
					var columnKeys = ['field', 'value'];

					if (benchmarkType === PERCENTILE || benchmarkType === DYNAMIC_COMPARISON) {
						columnKeys.push('bkey');
						columnKeys.push('bval');
					}

					var body = {
						fieldSetId: fieldSetId,
						sourceName: sourceName || DEFAULT_NAME,
						columnKeys: columnKeys,
						data: fields || [],
						benchmarkType: benchmarkType,
						metricType: metric
					};

					return body;
				}

				function getResultData(result) {
					return result.data;
				}

				return {
					/**
					 * Returns the benchmark sources.
					 * @param {string} fieldsetId
					 * @param {boolean} [opt_bypassCache] - Whether or not to bypass the cache
					 * @param {object} [opt_params] - An object containing the parameters
					 * @param {boolean} [opt_params.bypassLocalization] - Whether or not to retrieve the default benchmark name(s)
					 * @return {object}
					 */
					getSources: function (fieldsetId, opt_bypassCache, opt_params) {
						var config = rsTranslations.getTranslationConfig();
						if (opt_params) {
							config.params = opt_params;
						}
						return httpCache.get(getBenchmarkServiceURL(fieldsetId), config, !opt_bypassCache).then(getResultData);
					},

					getSourceFields: function (fieldsetId, sourceID, opt_bypassCache, opt_controlOptions) {
						return httpCache.get(getBenchmarkServiceURL(fieldsetId) + '/' + sourceID + '/fields', {}, !opt_bypassCache, opt_controlOptions).then(getResultData);
					},

					addSource: function (fieldsetId, sourceName, fields, metric, type) {
						var body = getBenchmarkBody(fieldsetId, sourceName, fields, metric, type);
						return httpCache.post(getBenchmarkServiceURL(fieldsetId), body).then(getResultData);
					},

					updateSource: function (fieldsetId, sourceName, sourceId, fields, metric, type) {
						var body = getBenchmarkBody(fieldsetId, sourceName, fields, metric, type);
						body.source_id = sourceId;

						return httpCache.put(getBenchmarkServiceURL(fieldsetId) + '/' + sourceId, body).then(getResultData);
					},

					deleteSource: function (fieldsetId, sourceId) {
						return httpCache['delete'](getBenchmarkServiceURL(fieldsetId) + '/' + sourceId).then(getResultData);
					},

					getBreakouts: function (fieldsetId, sourceId, fieldId) {
						return httpCache.get(
							getBenchmarkServiceURL(fieldsetId) + '/' + sourceId + '/fields/' + fieldId + '/breakouts').then(getResultData);
					},

					getPercentileBreakouts: function (fieldsetId, sourceId, fieldId, opt_bypassCache, opt_controlOptions) {
						return httpCache.get(
							getBenchmarkServiceURL(fieldsetId) + '/' + sourceId + '/fields/' + fieldId + '/breakouts/percent/values', {}, !opt_bypassCache, opt_controlOptions).then(getResultData);
					}
				};
			}
		]);
})();

(function(module) {
	'use strict';

	module.factory('rsContainers', [
		'$q',
		'containersHttp',
		'_rsContainersSaveQueue',
		'rsState',
		'rsEnvironment',
		'isTemplateContainer',
		'_rsWidgetsMetadata',
		'rsConfig',
		'routeTypes',
		function($q, containersHttp, containersSaveQueue, rsState, environment, isTemplateContainer, widgetsMetadata, rsConfig, routeTypes) {

			function getUrl(relativeUrl) {
				return rsConfig.getRoute(routeTypes.CONTAINERS) + (relativeUrl ? ('/' + relativeUrl ) : '');
			}

			function getResultSuccess(result) {
				var deferred = $q.defer();
				deferred.resolve(result.data);
				return deferred.promise;
			}

			function getResultError(result) {
				var deferred = $q.defer();
				deferred.reject(result);
				return deferred.promise;
			}

			return {
				createContainer: function(name, type, fieldSetId, opt_timezone, opt_attributes) {

					var containerDef = {
						containerType: type,
						description: name,
						product: environment.get('product') || environment.get('containerProduct'),
						fieldSetId: fieldSetId,
						pages: []
					};

					if (opt_timezone)
					{
						containerDef.timezone = opt_timezone;
					}

					if (opt_attributes) { // currently used for passing translation related attributes used by Vocalize
						_.forEach(opt_attributes, function(value, key) {
							containerDef[key] = value;
						});
					}

					return containersHttp.post(getUrl(), containerDef).then(getResultSuccess, getResultError);
				},
				deleteContainer: function (containerId) {
					return containersHttp.delete(getUrl(containerId)).then(getResultSuccess, getResultError);
				},
				getContainers: function(opt_product, opt_offset, opt_limit, opt_include_translation_attributes)
				{
					var qs = {};
					if (opt_product)
					{
						qs.product = opt_product;
					}
					if (opt_offset)
					{
						qs.offset = opt_offset;
					}
					if (opt_limit)
					{
						qs.limit = opt_limit;
					}
					if (opt_include_translation_attributes)
					{
						qs.translations = true;
					}
					return containersHttp.get(getUrl(), { params: qs });
				},
				getContainer: function(containerId, opt_product, opt_includeUserPages)
				{
					var qs = {};
					if (opt_product)
					{
						qs.product = opt_product;
					}
					qs.includeUserPages = opt_includeUserPages;
					return containersHttp.get(getUrl(containerId + '/compound'), { params: qs }).then(getResultSuccess, getResultError);
				},
				importContainer: function(containerDef, widgetStateDefs) {
					return containersHttp.post(getUrl('import'), {
						container: containerDef,
						widgetStates: widgetStateDefs
					}).then(getResultSuccess, getResultError);
				},
				exportContainer: function(containerId) {
					return containersHttp.get(getUrl(containerId + '/export')).then(getResultSuccess, getResultError);
				},
				overwriteContainer: function(sourceId, destinationId) {
					return containersHttp.post(getUrl('overwrite'), {
						sourceId: sourceId,
						destinationId: destinationId
					}).then(getResultSuccess, getResultError);
				},
				getAdminContainer: function() {
					var product = environment.get('product') || environment.get('containerProduct');
					var query = product ? '?type=' + product : '';

					return containersHttp.get(getUrl('adminPage' + query)).then(getResultSuccess, getResultError);
				},
				saveContainer: function(containerId, definition)
				{
					if (isTemplateContainer(containerId)) {
						return $q.when();
					}
					return containersSaveQueue.queuePut(containerId, getUrl(containerId), definition);
				},
				saveUserPages: function(containerId, definition, pageType)
				{
					var qs = {
						pageType: pageType
					};
					return containersSaveQueue.queuePut(containerId,  getUrl(containerId + '/pages'), definition, { params: qs });
				},
				patchContainer: function(containerId, containerPatch)
				{
					if (!containerId || !containerPatch) {
						return $q.reject(new Error('Usage: rsContainers.patchContainer(containerId, containerPatch)'));
					}
					if (isTemplateContainer(containerId)) {
						return $q.when({});
					}
					return containersSaveQueue.queuePatch(containerId, getUrl(containerId), containerPatch);
				},
				copyContainer: function(containerId, description, opt_fieldSetId, opt_contextMeta) {
					var qs = {
						sourceId: containerId,
						newDescription: description
					};
					return containersHttp.post(getUrl(), { fieldSetId: opt_fieldSetId, contextMeta: opt_contextMeta }, { params: qs }).then(getResultSuccess, getResultError);
				},
				getPage: function(containerId, pageId, pageType)
				{
					var qs = {
						pageType: pageType
					};
					return containersHttp.get(getUrl(containerId + '/pages/' + pageId), { params: qs }).then(getResultSuccess, getResultError);
				},
				addPage: function(containerId, page, pageType)
				{
					var qs = {
						pageType: pageType
					};
					if(!page.widgets)
					{
						page.widgets = [];
					}
					return containersHttp.post(getUrl(containerId + '/pages'), page, { params: qs }).then(getResultSuccess, getResultError);
				},
				savePage: function(containerId, page, pageType)
				{
					var qs = {
						pageType: pageType
					};
					if (!page || !page.hasOwnProperty('_id'))
					{
						return $q.reject('A page and page id must be provided');
					}
					return containersSaveQueue.queuePut(page._id, getUrl(containerId + '/pages/' + page._id), page, { params: qs });
				},
				patchPage: function(containerId, page, pageType)
				{
					var qs = {
						pageType: pageType
					};
					if (!page || !page.hasOwnProperty('_id'))
					{
						return $q.reject('A page and page id must be provided');
					}
					return containersSaveQueue.queuePatch(page._id, getUrl(containerId + '/pages/' + page._id), page, { params: qs });
				},
				deletePage: function(containerId, pageId, pageType)
				{
					var qs = {
						pageType: pageType
					};
					//clear out any pending save requests so they don't occor after the page is deleted
					containersSaveQueue.cancelSave(pageId);
					return containersHttp.delete(getUrl(containerId + '/pages/' + pageId), { params: qs }).then(getResultSuccess, getResultError);
				},
				copyPage: function(containerId, pageId, description, srcPageType, destPageType) {
					var qs = {
						sourceId: pageId,
						newDescription: description,
						pageType: srcPageType,
						toPageType: destPageType
					};
					return containersHttp.post(getUrl(containerId + '/pages'), {}, { params: qs }).then(getResultSuccess, getResultError);
				},
				addWidget: function(containerId, pageId, widget, pageType) {
					var qs = {
						pageType: pageType
					};
					return containersHttp.post(getUrl(containerId + '/pages/' + pageId + '/widgets'), widget, { params: qs })
						.then(function (result) {
							if (result && result.data && result.data._id) {
								rsState.setCachedState(result.data._id, pageId, containerId, {
									privateData: {},
									sharedData: {}
								});
							}
							return result;
						})
						.then(getResultSuccess, getResultError);
				},
				deleteWidget: function(containerId, pageId, widgetId, pageType) {
					//clear out any pending save requests so they don't occor after the widget is deleted
					containersSaveQueue.cancelSave(widgetId);
					var qs = {
						pageType: pageType
					};
					return containersHttp.delete(getUrl(containerId + '/pages/' + pageId + '/widgets/' + widgetId), { params: qs }).then(getResultSuccess, getResultError);
				},
				copyWidget: function(containerId, srcPageId, destPageId, widgetId, pageType) {
					var qs = {
						srcPageId: srcPageId,
						widgetId: widgetId,
						pageType: pageType
					};
					return containersHttp.post(getUrl(containerId + '/pages/' + destPageId + '/widgets'), {}, { params: qs }).then(getResultSuccess, getResultError);
				},
				addWidgetState: function(containerId, pageId, widgetId, widgetState, pageType) {
					var qs = {
						pageType: pageType
					};
					return containersHttp.post(getUrl(containerId + '/pages/' + pageId + '/widgets/' + widgetId + '/state'), widgetState, { params: qs })
						.then(function(result) {
							if (result && result.data && result.data.widgetId && result.data.data) {
								rsState.setCachedState(result.data.widgetId, pageId, containerId, result.data.data);
							}
							return result;
						})
						.then(getResultSuccess, getResultError);
				},
				getWidgetsMetaData: function(widgetTypes) {
					var deferred = $q.defer();

					var metaData = widgetsMetadata.getWidgetsMetaData(widgetTypes);

					deferred.resolve(metaData);

					return deferred.promise;
				},
				getContainerSnapshots: function(containerId, opt_offset, opt_limit) {
					var qs = {};
					if (opt_offset) {
						qs.offset = opt_offset;
					}
					if (opt_limit) {
						qs.limit = opt_limit;
					}
					return containersHttp.get(getUrl(containerId + '/snapshots/'), { params: qs });
				},
				addContainerSnapshot: function(containerId, description) {
					var qs = {
						newDescription: description
					};
					return containersHttp.post(getUrl(containerId + '/snapshots'), {}, { params: qs }).then(getResultSuccess, getResultError);
				},
				deleteAllContainerSnapshots: function(containerId) {
					return containersHttp.delete(getUrl(containerId + '/snapshots/')).then(getResultSuccess, getResultError);
				},
				replaceWithSnapshot: function(containerId, snapshotId) {
					return containersHttp.post(getUrl(containerId + '/snapshots/' + snapshotId), {}).then(getResultSuccess, getResultError);
				},
				flush: function(blocking)
				{
					containersSaveQueue.saveNow(!!blocking);
				}
			};
		}
	]);
})(angular.module('ripsaw'));

// API that picks either the container or snapshot data model for requests
(function(module) {
	'use strict';
	module.factory('rsDashboards', [
		'$q',
		'rsEnvironment',
		'rsContainers',
		'rsSnapshots',
		'_rsSnapshotUtil',
		function($q, env, containers, snapshots, snapshotUtil) {
			return {
				getDashboard: function() {
					var func = chooseServiceFunc(containers.getContainer, snapshots.getSnapshotCompound);
					return func.apply(null, arguments);
				},
				saveDashboard: function(containerId, definition) {
					if (snapshotUtil.isSnapshot()) {
						var snapshotId = env.get('containerSnapshotId');
						definition = _.clone(definition);
						definition._id = snapshotId;
						return snapshots.updateSnapshot(snapshotId, containerId, definition);
					} else {
						return containers.saveContainer(containerId, definition);
					}
				},
				patchDashboard: function(containerId, patch) {
					if (snapshotUtil.isSnapshot()) {
						var snapshotId = env.get('containerSnapshotId');
						if (patch._id) {
							patch = _.clone(patch);
							patch._id = snapshotId;
						}
						return snapshots.patchSnapshot(snapshotId, containerId, patch);
					} else {
						return containers.patchContainer(containerId, patch);
					}
				},
				getPage: function() {
					var func = chooseServiceFunc(containers.getPage, snapshots.getSnapshotPage);
					return func.apply(null, arguments);
				},
				addPage: function() {
					var func = chooseServiceFunc(containers.addPage, snapshots.addSnapshotPage);
					return func.apply(null, arguments);
				},
				savePage: function() {
					var func = chooseServiceFunc(containers.savePage, snapshots.saveSnapshotPage);
					return func.apply(null, arguments);
				},
				patchPage: function() {
					var func = chooseServiceFunc(containers.patchPage, snapshots.patchSnapshotPage);
					return func.apply(null, arguments);
				},
				deletePage: function() {
					var func = chooseServiceFunc(containers.deletePage, snapshots.deleteSnapshotPage);
					return func.apply(null, arguments);
				},
				copyPage: function() {
					var func = chooseServiceFunc(containers.copyPage, snapshots.copySnapshotPage);
					return func.apply(null, arguments);
				},
				addWidget: function() {
					var func = chooseServiceFunc(containers.addWidget, snapshots.addSnapshotWidget);
					return func.apply(null, arguments);
				},
				deleteWidget: function() {
					var func = chooseServiceFunc(containers.deleteWidget, snapshots.deleteSnapshotWidget);
					return func.apply(null, arguments);
				},
				copyWidget: function() {
					var func = chooseServiceFunc(containers.copyWidget, snapshots.copySnapshotWidget);
					return func.apply(null, arguments);
				},
				addWidgetState: function() {
					var func = chooseServiceFunc(containers.addWidgetState, snapshots.addSnapshotWidgetState);
					return func.apply(null, arguments);
				},
				getWidgetsMetaData: function(widgetTypes) {
					return containers.getWidgetsMetaData(widgetTypes);
				},
				flush: function(blocking) {
					return snapshotUtil.isSnapshot() ? snapshots.flush(blocking) : containers.flush(blocking);
				},
				patchContextMeta: function(containerId, contextMeta) {
					var patchOperation = {
						contextMeta: contextMeta
					};
					if (snapshotUtil.isSnapshot()) {
						return snapshots.patchSnapshot(env.get('containerSnapshotId'), containerId, patchOperation, true);
					} else {
						return containers.patchContainer(containerId, patchOperation);
					}
				}
			};

			function chooseServiceFunc(containerFunc, snapshotFunc) {
				return snapshotUtil.isSnapshot() ? _.partial(snapshotFunc, env.get('containerSnapshotId')) : containerFunc;
			}
		}
	]);
})(angular.module('ripsaw'));

(function(module) {
	'use strict';
	module.factory('rsEditEvents', [
		'pageTypes',
		function(pageTypes) {
			var callbacks = [];

			return {
				log: function(optPageType) {
					if (optPageType === pageTypes.USER_PAGE) {
						return;
					}
					_.forEach(callbacks, function(callback) {
						_.isFunction(callback) && callback();
					});
				},
				listen: function(callback) {
					callbacks.push(callback);
					return function off() {
						_.remove(callbacks, function(cb) {
							return cb === callback;
						});
					};
				}
			};
		}
	]);
})(angular.module('ripsaw'));

(function(module) {
	'use strict';

	module.value('_rsEnvironment',{});
	module.factory('rsEnvironment', [
		'_rsEnvironment',
		function(environment)
		{
			return {
				get: function(key, propertyPath)
				{
					var ret;
					if (typeof environment[key] !== 'undefined')
					{
						ret = environment[key];

						if(typeof propertyPath === 'string')
						{
							ret = ret[propertyPath];
						}

						//return a copy so that consumers of this can't modify it without calling 'set'
						ret = _.cloneDeep(ret);
					}
					return ret;
				},

				getWithoutCloning: function(key)
				{
					return environment[key];
				},

				set: function(key, value)
				{
					var ret;
					if (key !== null && typeof key !== 'undefined')
					{
						if (typeof value === 'undefined')
						{
							ret = environment[key];
							delete environment[key];
						}
						else
						{
							//clone this value so that we can guarantee the env is a SSOT
							ret = (environment[key] = _.cloneDeep(value));
						}
					}

					return ret;
				},
				add: function(values)
				{
					if (!values)
					{
						return;
					}

					angular.extend(environment, values);
				},
				//backwards compatibility
				getEnvironmentVariable: function(key)
				{
					return this.get(key);
				}
			};
		}
	]);
})(angular.module('ripsaw'));

(function(module) {
	'use strict';

	module.factory('rsFieldsetsV2', [
		'$q',
		'rsFieldsetsV2.internal.fieldsets',
		'rsFieldsetsV2.internal.records',
		'rsFieldsetsV2.internal.aggregates',
		'rsFieldsetProgress',
		'rsFieldsetsV2.internal.weights',
		'rsFieldsetsV2.internal.decorators',
		'rsPublishing',
		'uuid',
		'_rsActiveRequestCache',
		'publishingConstants',
		function($q, fieldsetAPI, recordsAPI, aggregateAPI, progressService, weightingService, decoratorService, rsPublishing, uuid, requestCache, publishingConstants)
		{

			// ============= FIELDSETS =============
			function create(fieldset) {
				if (typeof fieldset === 'string')
				{
					var fieldSetId = uuid.generate();
					fieldset = {
						name: fieldset,
						fieldSetId: fieldSetId,
						fields: {}
					};
				}
				return fieldsetAPI.create(fieldset).then(returnResponseData);
			}

			function createCopy(fieldset) {
				var fieldsetCopy = {
					name: fieldset.name,
					fieldSetId: uuid.generate(),
					fields: fieldset.fields,
					metaFields: fieldset.metaFields || {}
				};
				return fieldsetAPI.create(fieldsetCopy).then(returnResponseData);
			}

			function update() {
				return fieldsetAPI.update.apply(fieldsetAPI, arguments).then(returnResponseData);
			}

			function del() {
				return fieldsetAPI['delete'].apply(fieldsetAPI, arguments).then(returnResponseData);
			}

			function get(requestOptions, controlOptions) {
				requestOptions = requestOptions || {};
				var newOptions = _.pick(requestOptions, ['offset', 'limit', 'include', 'useCache', 'assumeHasPermission']);
				if (requestOptions.context)
				{
					newOptions.keyName = requestOptions.context.key;
					newOptions.keyValue = requestOptions.context.value;
				}
				if (rsPublishing.useUnpublishedFieldset()) {
					newOptions[publishingConstants.PARAMETER] = publishingConstants.UNPUBLISHED;
				}
				return fieldsetAPI.get(newOptions, controlOptions).then(function(response) {
					if (requestOptions.getFirst) {
						return response.data[0] || [];
					} else {
						return response.data;
					}
				});
			}

			function getById() {
				return fieldsetAPI.getById.apply(fieldsetAPI, arguments).then(returnResponseData);
			}

			function getVersionsById() {
				return fieldsetAPI.getVersionsById.apply(fieldsetAPI, arguments).then(returnResponseData);
			}

			function requestHeadById() {
				return fieldsetAPI.requestHeadById.apply(fieldsetAPI, arguments);
			}

			function getByContext(key, value, requestOptions) {
				requestOptions = requestOptions || {};

				requestOptions.context = {
					key: key,
					value: value
				};

				return service.get(requestOptions);
			}

			function getFields(fieldSetId, requestOptions, controlOptions) {
				return service.getById(fieldSetId, requestOptions, controlOptions).then(function(fieldset) {
					return fieldset.fields;
				});
			}

			function getFieldDomain(fieldSetId, fieldId) {
				return service.getFields(fieldSetId).then(function(fields) {
					if (!fields[fieldId]) {
						return $q.reject(new Error('Field "' + fieldId + '" does not exist in the fieldset'));
					} else {
						return fields[fieldId] && fields[fieldId].domain || [];
					}
				});
			}

			// ============= AGGREGATES =============
			function getUniqueResponseValues(fieldSetId, fieldId, requestOptions, controlOptions) {
				requestOptions = _.cloneDeep(requestOptions) || {};
				var metrics = [
					{
						field: '_recordId',
						key: '_recordId_count',
						metric: 'count'
					}
				];
				var breakouts = [fieldId];
				var filter = requestOptions.filter || {};

				function returnError(reason) {
					return $q.reject(reason);
				}

				function extractFieldValues(response) {
					// Extract field values from aggregate response
					if (!response.data || !response.data.keys || !response.data.values)
					{
						return $q.reject(new Error('getUniqueResponseValues: Expected response to contain "data" property with "keys" and "values" properties'));
					}

					var valueIndex = _.findIndex(response.data.keys, function(key) {
						// check if key is substring of fieldId because of possible date syntax
						return fieldId.indexOf(key) !== -1;
					});
					var uniqueResponseValues = _.map(response.data.values, valueIndex);
					return uniqueResponseValues;
				}

				return service.getAggregate(fieldSetId, metrics, breakouts, filter, requestOptions, controlOptions)
					.then(extractFieldValues, returnError, extractFieldValues);
			}

			function getAggregate(fieldSetId, metrics, breakouts, filter, requestOptions, controlOptions) {
				//clone the non-primitive args in case the caller modifies the references before we're done here,
				//since we store them locally and use them again later in the case of re-requesting unsampled data.
				metrics = _.cloneDeep(metrics);
				breakouts = _.cloneDeep(breakouts);
				filter = _.cloneDeep(filter);
				requestOptions = _.cloneDeep(requestOptions) || {};

				if (rsPublishing.useUnpublishedFieldset()) {
					requestOptions[publishingConstants.PARAMETER] = publishingConstants.UNPUBLISHED;
					delete requestOptions.snapshotId;
				}

				var deferredResults = $q.defer();
				aggregateAPI.getAggregate(fieldSetId, metrics, breakouts, filter, requestOptions, controlOptions)
					.then(_handleAsyncAggregateResponse)
					.then(returnResponseData)
					.then(waitForFullData(controlOptions, deferredResults, function() {
						requestOptions.useCache = false; //don't use the cached result! it's sampled!
						delete requestOptions.snapshotId;
						return aggregateAPI.getAggregate(fieldSetId, metrics, breakouts, filter, requestOptions, controlOptions);
					}))
					['catch'](function(err) {
						if (err.status !== 0) {
							logError('Error requesting aggregate data: ', err);
						}
						deferredResults.reject(err);
					});
				return deferredResults.promise;

				function _handleAsyncAggregateResponse(response) {
					if (response && response.status === 202) {
						var token = response.data && response.data.token;
						return aggregateAPI.getAggregateAsync(
							fieldSetId,
							token,
							controlOptions,
							requestOptions.snapshotId
						);
					}
					return response;
				}
			}

			function getWordCount(fieldSetId, fieldId, requestOptions, controlOptions) {
				var deferredResults = $q.defer();
				requestOptions = _.cloneDeep(requestOptions) || {}; //clone this in case caller modifies it before we're done here.
				if (rsPublishing.useUnpublishedFieldset()) {
					requestOptions[publishingConstants.PARAMETER] = publishingConstants.UNPUBLISHED;
				}
				aggregateAPI.getWordCount(fieldSetId, fieldId, requestOptions)
					.then(returnResponseData)
					.then(waitForFullData(controlOptions, deferredResults, function() {
						requestOptions.useCache = false; //don't use the cached result! it's sampled!
						return aggregateAPI.getWordCount(fieldSetId, fieldId, requestOptions, controlOptions);
					}))
					['catch'](function(err) {
						if (err.status !== 0) {
							logError('Error requesting wordCount data: ', err);
						}
						deferredResults.reject(err);
					});
				return deferredResults.promise;
			}

			// ============= RECORDS =============
			function getRecords(fieldSetId, requestOptions, controlOptions) {
				requestOptions = requestOptions || {};
				requestOptions.useCache = (typeof requestOptions.useCache === 'undefined') ? true : requestOptions.useCache;

				var reqOptions = _.pick(requestOptions, ['offset', 'limit', 'fields', 'filter', 'sort', 'useCache', 'snapshotId', 'requestTag', 'timezone', 'customPeriods']);
				if (rsPublishing.useUnpublishedFieldset()) {
					reqOptions[publishingConstants.PARAMETER] = publishingConstants.UNPUBLISHED;
				}

				var deferredResults = $q.defer();
				recordsAPI.get(fieldSetId, reqOptions, controlOptions)
					.then(returnResponseData)
					.then(waitForFullData(controlOptions, deferredResults, function() {
						reqOptions.useCache = false; //don't use the cached result! it's sampled!
						return recordsAPI.get(fieldSetId, reqOptions, controlOptions);
					}))
					['catch'](function(err) {
						if (err.status !== 0) {
							logError('Error requesting records data: ', err);
						}
						deferredResults.reject(err);
					});

				return deferredResults.promise;
			}

			function getRecord() {
				return recordsAPI.getById.apply(recordsAPI, arguments).then(returnResponseData);
			}

			function updateRecord(fieldsetId, recordId, record, requestOptions, controlOptions) {
				var deferredResults = $q.defer();
				recordsAPI.update(fieldsetId, recordId, record, requestOptions, controlOptions)
					.then(waitUntilProgressCompletes(deferredResults))
					['catch'](function(err) {
						logError('Error updating record: ', err);
						deferredResults.reject(err);
					});
				return deferredResults.promise;
			}

			function updateRecords(fieldSetId, updatedRecords, requestOptions, controlOptions) {
				var deferredResults = $q.defer();
				recordsAPI.updateBatch(fieldSetId, updatedRecords, requestOptions, controlOptions)
					.then(waitUntilProgressCompletes(deferredResults))
					['catch'](function(err) {
						logError('Error updating records: ', err);
						deferredResults.reject(err);
					});
				return deferredResults.promise;
			}

			function updateRecordsByFilter(fieldSetId, values, filter, requestOptions, controlOptions) {
				var postBody = {
					values: values,
					filter: filter
				};
				var deferredResults = $q.defer();
				recordsAPI.updateBatch(fieldSetId, postBody, requestOptions, controlOptions)
					.then(waitUntilProgressCompletes(deferredResults))
					['catch'](function(err) {
						logError('Error updating records: ', err);
						deferredResults.reject(err);
					});
				return deferredResults.promise;
			}

			function deleteRecord(fieldSetId, recordId, requestOptions, controlOptions) {
				var deferredResults = $q.defer();
				recordsAPI['delete'](fieldSetId, recordId, requestOptions, controlOptions)
					.then(waitUntilProgressCompletes(deferredResults))
					['catch'](function(err) {
						logError('Error deleting record: ', err);
						deferredResults.reject(err);
					});
				return deferredResults.promise;
			}

			function deleteRecords(fieldSetId, requestOptions, controlOptions) {
				var deferredResults = $q.defer();
				recordsAPI.deleteBatch(fieldSetId, requestOptions, controlOptions)
					.then(waitUntilProgressCompletes(deferredResults))
					['catch'](function(err) {
						logError('Error deleting records: ', err);
						deferredResults.reject(err);
					});
				return deferredResults.promise;
			}

			function revertRecord(fieldSetId, recordId, fieldId, requestOptions) {
				var deferredResults = $q.defer();
				recordsAPI.revert(fieldSetId, recordId, fieldId, requestOptions)
					.then(deferredResults.resolve)
					['catch'](function(err) {
						logError('Error reverting record: ', err);
						deferredResults.reject(err);
					});
				return deferredResults.promise;
			}

			// ============= HELPER FUNCTIONS =============
			function waitForFullData(controlOptions, deferredResults, requestFullData) {
				return function(data) {
					var poll = !controlOptions || controlOptions.waitForCompletion !== false;
					if (poll && isSampledData(data))
					{
						deferredResults.notify(data);

						progressService.waitForCompletion(data.meta.progress)
							.then(requestFullData)
							.then(returnResponseData)
							.then(deferredResults.resolve)
							['catch'](deferredResults.reject);
					}
					else
					{
						deferredResults.resolve(data);
					}

					return deferredResults.promise;
				};
			}

			function waitUntilProgressCompletes(deferredResults) {
				return function(body) {
					var progressId = body.data && body.data.progress;
					deferredResults.notify(progressId);
					return progressService.waitForCompletion(progressId)
						.then(deferredResults.resolve);
				};
			}

			function isSampledData(response) {
				return (response && response.meta && response.meta.sample);
			}

			function returnResponseData(response) {
				return response && response.data || {};
			}

			function clearPendingRequests() {
				// Clears existing tagged data requests
				requestCache.clearRequests();
			}

			function logError(msg, err) {
				console.error(msg, JSON.stringify(err));
			}

			var service = {
				clearPendingRequests: clearPendingRequests,

				// Fieldsets
				create: create,
				createCopy: createCopy,
				update: update,
				'delete': del,
				get: get,
				getById: getById,
				getVersionsById: getVersionsById,
				requestHeadById: requestHeadById,
				getByContext: getByContext,
				getFields: getFields,
				getFieldDomain: getFieldDomain,
				setAEstatus: fieldsetAPI.setAEstatus,

				// Aggregates
				getUniqueResponseValues: getUniqueResponseValues,
				getAggregate: getAggregate,
				getWordCount: getWordCount,

				// Records
				getRecords: getRecords,
				getRecord: getRecord,
				updateRecord: updateRecord,
				updateRecords: updateRecords,
				updateRecordsByFilter: updateRecordsByFilter,
				deleteRecord: deleteRecord,
				deleteRecords: deleteRecords,
				revertRecord: revertRecord,

				// Weighting
				addWeighting: weightingService.post,
				getWeighting: weightingService.get,
				updateWeighting: weightingService.put,
				deleteWeighting: weightingService['delete'],

				// Generic Fieldset Decorators
				addDecorator: decoratorService.post,
				getDecorator: decoratorService.get,
				updateDecorator: decoratorService.put,
				deleteDecorator: decoratorService.deleteDecorator,

			};

			return service;
		}
	]);
})(angular.module('ripsaw'));

/*
 * widget-core log service
 * Posts logs to an external service
 * UPDATE: as of v1.0.34, this no longer posts logs anywhere.
 * It's just a straight pass-thru to $log until we re-design logging.
 */
(function(module) {
	'use strict';
	module.factory('rsLog', [
		'$log',
		function($log)
		{
			function log(type, value)
			{
				value = Array.prototype.slice.call(value);
				$log[type].apply($log, value);
			}

			return {
				log: function() {
					log('log', arguments);
				},
				warn: function() {
					log('warn', arguments);
				},
				info: function() {
					log('info', arguments);
				},
				error: function() {
					log('error', arguments);
				}
			};
		}
	]);

	module.factory('log', ['rsLog', function(log) {
		return log;
	}]);

})(angular.module('ripsaw'));
(function(module) {
	'use strict';
	module.factory('rsPerformanceAggregator', [
		'requestAggregator',
		'rsEnvironment',
		function(Aggregator, env) {

			var config = {
				url: '/widget/performance',
				timeout: 10000
			};
			var product = env.get('product') || env.get('containerProduct');
			var requestAggregator = new Aggregator(config);

			return {
				pushData: function(metric) {
					if(requestAggregator.timedOut || requestAggregator.finished) {
						requestAggregator = new Aggregator(config);
					}
					metric.product = product;
					requestAggregator.post('', metric);
				}
			};
		}
	]);
})(angular.module('ripsaw'));
(function(app) {
	'use strict';

	app.factory('rsPermissions', [
		'$http',
		'rsConfig',
		'routeTypes',
		function($http, rsConfig, routeTypes) {

			function getBaseUrl() {
				return rsConfig.getRoute(routeTypes.PERMISSIONS);
			}

			function returnResponseData(response) {
				return response.data;
			}

			return {
				getResourceByPermissionSlug: function(slug) {
					var path = getBaseUrl() + '/resource-permissions';
					var config = {
						params: {
							permission: slug
						}
					};

					return $http.get(path, config).then(returnResponseData);
				},
				getUserList: function(brandId, type, namespace, slug, includeSource) {
					var path = getBaseUrl() + '/users';
					var config = {
						params: {
							brandId: brandId,
							type: type,
							namespace: namespace,
							slug: slug,
							includeSource: includeSource
						}
					};

					return $http.get(path, config).then(returnResponseData);
				},
				getUserResources: function(userId, slug, brandId) {
					var path = getBaseUrl() + '/user/' + userId + '/resources';
					var config = {
						params: {
							slug: slug,
							brandId: brandId
						}
					};

					return $http.get(path, config).then(returnResponseData);
				},
				getCurrentUserPermissions: function(resource, opt_params) {
					var path = getBaseUrl() + '/user-permissions';
					var config = {
						params: {
							resource: resource
						}
					};

					_.extend(config.params, opt_params || {});
					return $http.get(path, config).then(returnResponseData);
				},
				getUserPermissions: function(userId, type, slug, brandId, namespace, contextId) {
					var path = getBaseUrl() + '/user/' + userId;
					var config = {
						params: {
							contextId: contextId || '$none',
							type: type,
							slug: slug,
							brandId: brandId,
							namespace: namespace
						}
					};

					return $http.get(path, config)
						.then(returnResponseData)
						.then(function(userObj) {
							return userObj.permissions;
						});
				},
				getPermissions: function(permissionSourceType, permissionSourceId, opt_brandId) {
					permissionSourceType = permissionSourceType.toLowerCase();

					var path = getBaseUrl() + '/' + permissionSourceType + '/' + permissionSourceId;

					var pathExtensions = {
						user: '',
						role: '/permissions',
						brand: '/permissions'
					};

					var responseMappingFuncs = {
						user: function(responseData) {
							// RoleService returns an object with a `permissions` key instead of just an array of permissions
							return responseData.permissions;
						},
						role: _.identity,
						brand: _.identity
					};

					// mock brandId to resource brandId for cross brand sharing
					var config = {};
					if(permissionSourceType === 'role') {
						config.params = {
							brandId: opt_brandId
						};
					}

					var pathExtension = pathExtensions[permissionSourceType];

					return $http.get(path + pathExtension, config)
						.then(returnResponseData)
						.then(function(responseData) {
							return responseMappingFuncs[permissionSourceType](responseData);
						});
				},
				updatePermissions: function(permissionsArray, permissionSourceType, permissionSourceId) {
					var path = getBaseUrl() + '/' + permissionSourceType + '/' + permissionSourceId;

					var permissionRequestObj = {
						action: 'update',
						permissions: permissionsArray
					};
					return $http.put(path, permissionRequestObj)
						.then(returnResponseData);
				},
				removePermissions: function(permissionsArray, permissionSourceType, permissionSourceId) {
					var path = getBaseUrl() + '/' + permissionSourceType + '/' + permissionSourceId;

					var permissionRequestObj = {
						action: 'remove',
						permissions: permissionsArray
					};
					return $http.put(path, permissionRequestObj)
						.then(returnResponseData);
				},
				getResourceByNamespace: function(namespace) {
					var path = getBaseUrl() + '/resources';
					var config = {
						params: {
							namespace: namespace
						}
					};
					return $http.get(path, config).then(returnResponseData);
				}
			};

		}
	]);
})(angular.module('ripsaw'));

(function(module) {
	'use strict';

	module.factory('rsPublishing', [
		'rsEnvironment',
		function(env) {
			var publishingEnabled = false;
			var unpublishedFieldsetExists = false;
			var fieldsetPublishingV2Enabled = false;
			return {
				hasUnpublishedFieldset: function() {
					return unpublishedFieldsetExists;
				},
				useUnpublishedFieldset: function() {
					var usePublishingV1 = publishingEnabled && unpublishedFieldsetExists && env.get('fieldSetId') === env.get('containerFieldsetId') && env.get('isDashboardEditor');
					var usePublishingV2 = fieldsetPublishingV2Enabled && env.get('isDashboardEditor');
					return usePublishingV1 || usePublishingV2;
				},
				setPublishingEnabled: function(val) {
					publishingEnabled = val;
				},
				setUnpublishedFieldsetExists: function(val) {
					unpublishedFieldsetExists = val;
				},
				setFieldsetPublishingV2Enabled: function(val) {
					fieldsetPublishingV2Enabled = val;
				},
				isFieldsetPublishingV2Enabled: function() {
					return fieldsetPublishingV2Enabled;
				}
			};
		}
	]);
})(angular.module('ripsaw'));

(function(module) {
	'use strict';

	module.value('_rsResourceCache', {
		widgets: {},
		dependencies: {}
	});
})(angular.module('ripsaw'));
'use strict';

angular.module('ripsaw').factory('rsResponsesV2.recordUpdateService', [
	'$interval',
	'rsResponsesV2',
	'rsResponsesV2.responseRecordConverter',
	function ($interval, responses, responseRecordConverter) {
		return {
			fromStream: function (dataStream, responseSetId, options) {
				options = options || {};
				var delay = options.delay || 1000;
				var maxRecordsPerUpdate = options.maxRecordsPerUpdate || 1000;
				var interval;

				function cancel() {
					$interval.cancel(interval);
					flush();
				}

				function flush() {
					var subset = dataStream.slice(0, maxRecordsPerUpdate);
					var length = subset.length;

					if (length > 0) {
						var records = _.map(subset, responseRecordConverter.fromObject);
						responses.createResponses(responseSetId, records, 'Record')
							.then(function () {
								dataStream.splice(0, length);
							})
							.catch(angular.noop);
					}
				}

				interval = $interval(flush, delay);
				return {
					cancel: cancel,
					flush: flush
				};
			}
		};
	}
]);

'use strict';

angular.module('ripsaw').factory('rsResponsesV2.responseRecordConverter',
	function () {
		function getType(object) {
			return ({
				'[object Boolean]': 'booleanValue',
				'[object Date]': 'dateValue',
				'[object Number]': 'numberValue',
				'[object String]': 'textValue'
			})[Object.prototype.toString.call(object)] || 'textValue';
		}

		function toString(object) {
			return object instanceof Date ? object.toISOString() : '' + object;
		}

		function getRecordedDate() {
			return toString(new Date());
		}

		return {
			fromObject: function (object) {
				var result = {};
				_.forOwn(object, function (value, key) {
					(result[key] = {})[getType(value)] = toString(value);
				});
				var meta = {
					recordedDate: getRecordedDate()
				};
				return { data: result, meta: meta };
			}
		};
	});

'use strict';

angular.module('ripsaw').factory('rsResponsesV2', [
	'$http',
	'rsConfig',
	'routeTypes',
	function ($http, rsConfig, routeTypes) {
		var responsesUrl = rsConfig.getRoute(routeTypes.RESPONSES);

		function getResponsesUrl(responseSetId) {
			return responsesUrl + '/' + responseSetId;
		}

		return {
			createResponses: function (responseSetId, response, format) {
				return $http.post(getResponsesUrl(responseSetId),
					angular.toJson({ response: response }), {
						params: { format: format }
					});
			},
			getResponses: function (responseSetId, limit, offset) {
				return $http.get(getResponsesUrl(responseSetId), {
					params: {
						limit: limit,
						offset: offset
					}
				});
			}
		};
	}
]);

(function(app) {
	'use strict';

	app.factory('rsRoles', [
		'$http',
		'rsEnvironment',
		'rsConfig',
		'routeTypes',
		function($http, env, rsConfig, routeTypes) {

			function getBaseUrl() {
				return rsConfig.getRoute(routeTypes.PERMISSIONS);
			}

			function getResultSuccess(result) {
				return result && result.data;
			}

			function putRole(roleId, body, action) {
				body = angular.extend({}, body, {action: action});
				return $http.put(getBaseUrl() + '/role/' + roleId, body).then(getResultSuccess);
			}

			return {
				getRoleDefinitionsForBrand: function(optBrandId, extraParams) {
					var queryParams = Object.assign({brandId: optBrandId}, extraParams);
					return $http.get(getBaseUrl() + '/roles/definitions', {
						params: queryParams
					}).then(getResultSuccess);
				},
				getRolesForBrand: function(optBrandId, extraParams) {
					var queryParams = Object.assign({brandId: optBrandId}, extraParams);
					return $http.get(getBaseUrl() + '/roles', {
						params: queryParams
					}).then(getResultSuccess);
				},
				getRolesForUser: function(userId, extraParams) {
					var queryParams = Object.assign({userId: userId}, extraParams);
					return $http.get(getBaseUrl() + '/roles', {
						params: queryParams
					}).then(getResultSuccess);
				},
				createRole: function(role) {
					var body = angular.copy(role);
					var brandId = env.get('user').brandId;
					angular.extend(body.roleDef, {brandId: brandId});

					return $http.post(getBaseUrl() + '/roles', body)
							.then(getResultSuccess);
				},
				deleteRole: function(roleId) {
					return $http['delete'](getBaseUrl() + '/role/' + roleId)
							.then(getResultSuccess);
				},
				addUsersToRole: function(roleId, userIds) {
					return putRole(roleId, {users: userIds}, 'update');
				},
				removeUsersFromRole: function(roleId, userIds) {
					return putRole(roleId, {users: userIds}, 'remove');
				},
				updateRoleDefinition: function(roleId, roleDef) {
					return putRole(roleId, {roleDef: roleDef}, 'update');
				}
			};
		}
	]);
})(angular.module('ripsaw'));

(function (module) {
	'use strict';

	module.factory('rsContainersRetryConfig', [
		function () {
			var SHOULD_RETRY_STATUS_CODE = 429;
			var MAX_RETRIES = 3;
			var INITIAL_DELAY = 60000;
			var MAX_DELAY = 300000;
			/**
			 * This function is a default provided to retry on containers throttling. By adding this function as the `shouldRetry` parameter in the
			 * control options, ripsaw components using the containers API will retry throttled http requests.
			 */
			var containersShouldRetry = function (response) {
				return response.status === SHOULD_RETRY_STATUS_CODE;
			};
			/**
			 * Setup the containers retry control options to align with containers API throttling
			 */
			var containersControlOptions = {
				maxRetries: MAX_RETRIES,
				maxDelay: MAX_DELAY,
				initialDelay: INITIAL_DELAY,
				shouldRetry: containersShouldRetry
			};
			return {
				containersControlOptions: containersControlOptions
			};
		}
	]);
})(angular.module('ripsaw'));

(function (module) {
	'use strict';

	module.provider('rsFieldsetRetryConfig', function RsFieldsetRetryConfigProvider() {
		var fieldsetControlOptions = {};
		var defaultOptions = {
			maxRetries: 3,
			maxDelay: 5000,
			initialDelay: 100,
			shouldRetry: _.constant(false)
		};

		/**
		 * This function is a default provided to retry on fieldset throttling from
		 * response engine. By adding this function as the `shouldRetry` parameter in the
		 * rsFieldsetRetryConfig initialization, ripsaw components using the fieldsets API will retry http requests
		 */
		this.fieldsetsShouldRetry = function (response) {
			return response.status === 429;
		};

		/**
		 * An application can initialize the control options available to http
		 * requests using the fieldsets API using this initialization function.
		 */
		this.fieldsetInit = function (newOptions) {
			fieldsetControlOptions = newOptions;
		};

		this.$get = function () {
			return {
				fieldsetControlOptions: _.defaults(fieldsetControlOptions, defaultOptions)
			};
		};
	});
})(angular.module('ripsaw'));

(function (module) {
	'use strict';

	module.provider('rsMobileConfig', [
		function () {
			var mobileConfig = {};

			/**
			 * Allows the application to set the configuration to use for enabling and disabling
			 * mobile mode for widgets dependent on ripsaw client.
			 */
			function setMobileConfig(config) {
				mobileConfig = config;
			}

			/**
			 * Returns whether or not the application has ripsaw client in a mobile environment.
			 */
			function isMobileMode() {
				return !!mobileConfig.enableMobileMode;
			}

			function $get() {
				return {
					isMobileMode: isMobileMode
				};
			}

			return {
				setMobileConfig: setMobileConfig,
				$get: $get
			};
		}
	]);
})(angular.module('ripsaw'));

(function(module) {
	'use strict';

	module.factory('rsSnapshots', [
		'$q',
		'containersHttp',
		'_rsContainersSaveQueue',
		'rsState',
		'rsEditEvents',
		'rsConfig',
		'rsFieldsetsV2',
		'routeTypes',
		function($q, containersHttp, containersSaveQueue, rsState, editEvents, rsConfig, rsFieldsets, routeTypes) {

			function getUrl(relativeUrl) {
				return rsConfig.getRoute(routeTypes.CONTAINERS) + (relativeUrl ? ('/' + relativeUrl ) : '');
			}

			function getResultSuccess(result) {
				return result.data;
			}

			function getSnapshot(snapshotId, containerId, opt_includeUserPages) {
				var qs = {};
				qs.includeUserPages = opt_includeUserPages;
				return containersHttp.get(getUrl(containerId + '/snapshots/' + snapshotId), { params: qs }).then(getResultSuccess);
			}

			return {
				getSnapshot: getSnapshot,
				// mock containers compound call
				getSnapshotCompound: function(snapshotId, containerId, opt_product, opt_includeUserPages) {
					return getSnapshot(snapshotId, containerId, opt_includeUserPages)
						.then(function(result) {
							return {
								definition: result,
								permissions: {}
							};
						});
				},
				deleteSnapshot: function(snapshotId, containerId) {
					return containersHttp.delete(getUrl(containerId + '/snapshots/' + snapshotId)).then(getResultSuccess);
				},
				updateSnapshot: function(snapshotId, containerId, definition) {
					return containersSaveQueue.queuePut(snapshotId, getUrl(containerId + '/snapshots/' + snapshotId), definition)
						.then(function(result) {
							editEvents.log();
							return result;
						});
				},
				patchSnapshot: function(snapshotId, containerId, snapshotPatch, opt_patchContainer) {
					var qs = {
						patchContainer: opt_patchContainer
					};
					return containersSaveQueue.queuePatch(snapshotId, getUrl(containerId + '/snapshots/' + snapshotId), snapshotPatch, { params: qs })
						.then(function(result) {
							if (!opt_patchContainer) {
								editEvents.log();
							}
							return result;
						});
				},
				getSnapshotPage: function(snapshotId, containerId, pageId, pageType) {
					var qs = {
						pageType: pageType
					};
					return containersHttp.get(getUrl(containerId + '/snapshots/' + snapshotId + '/pages/' + pageId), { params: qs }).then(getResultSuccess);
				},
				addSnapshotPage: function(snapshotId, containerId, page, pageType) {
					var qs = {
						pageType: pageType
					};
					if (!page.widgets)
					{
						page.widgets = [];
					}
					return containersHttp.post(getUrl(containerId + '/snapshots/' + snapshotId + '/pages'), page, { params: qs })
						.then(getResultSuccess)
						.then(function(result) {
							editEvents.log(pageType);
							return result;
						});
				},
				saveSnapshotPage: function(snapshotId, containerId, page, pageType) {
					var qs = {
						pageType: pageType
					};
					if (!page || !page.hasOwnProperty('_id'))
					{
						return $q.reject('A page and page id must be provided');
					}
					return containersSaveQueue.queuePut(page._id, getUrl(containerId + '/snapshots/' + snapshotId + '/pages/' + page._id), page, { params: qs })
						.then(function(result) {
							editEvents.log(pageType);
							return result;
						});
				},
				patchSnapshotPage: function(snapshotId, containerId, page, pageType) {
					var qs = {
						pageType: pageType
					};
					if (!page || !page.hasOwnProperty('_id'))
					{
						return $q.reject('A page and page id must be provided');
					}
					return containersSaveQueue.queuePatch(page._id, getUrl(containerId + '/snapshots/' + snapshotId + '/pages/' + page._id), page, { params: qs })
						.then(function(result) {
							editEvents.log(pageType);
							return result;
						});
				},
				deleteSnapshotPage: function(snapshotId, containerId, pageId, pageType) {
					var qs = {
						pageType: pageType
					};
					//clear out any pending save requests so they don't occur after the page is deleted
					containersSaveQueue.cancelSave(pageId);
					return containersHttp.delete(getUrl(containerId + '/snapshots/' + snapshotId + '/pages/' + pageId), { params: qs })
						.then(getResultSuccess)
						.then(function(result) {
							editEvents.log(pageType);
							return result;
						});
				},
				copySnapshotPage: function(snapshotId, containerId, pageId, description, srcPageType, destPageType) {
					var qs = {
						sourceId: pageId,
						newDescription: description,
						pageType: srcPageType,
						toPageType: destPageType
					};
					return containersHttp.post(getUrl(containerId + '/snapshots/' + snapshotId + '/pages'), {}, { params: qs })
						.then(getResultSuccess)
						.then(function(result) {
							editEvents.log(destPageType);
							return result;
						});
				},
				addSnapshotWidget: function(snapshotId, containerId, pageId, widget, pageType) {
					var qs = {
						pageType: pageType
					};
					return containersHttp.post(getUrl(containerId + '/snapshots/' + snapshotId + '/pages/' + pageId + '/widgets'), widget, { params: qs })
						.then(function (result) {
							if (result && result.data && result.data._id) {
								rsState.setCachedState(result.data._id, pageId, containerId, {
									privateData: {},
									sharedData: {}
								}, snapshotId);
							}
							return result;
						})
						.then(getResultSuccess)
						.then(function(result) {
							editEvents.log(pageType);
							return result;
						});
				},
				deleteSnapshotWidget: function(snapshotId, containerId, pageId, widgetId, pageType) {
					//clear out any pending save requests so they don't occor after the widget is deleted
					containersSaveQueue.cancelSave(widgetId);
					var qs = {
						pageType: pageType
					};
					return containersHttp.delete(getUrl(containerId + '/snapshots/' + snapshotId + '/pages/' + pageId + '/widgets/' + widgetId), { params: qs })
						.then(getResultSuccess)
						.then(function(result) {
							editEvents.log(pageType);
							return result;
						});
				},
				copySnapshotWidget: function(snapshotId, containerId, srcPageId, destPageId, widgetId, pageType) {
					var qs = {
						srcPageId: srcPageId,
						widgetId: widgetId,
						pageType: pageType
					};
					return containersHttp.post(getUrl(containerId + '/snapshots/' + snapshotId + '/pages/' + destPageId + '/widgets'), {}, { params: qs })
						.then(getResultSuccess)
						.then(function(result) {
							editEvents.log(pageType);
							return result;
						});
				},
				addSnapshotWidgetState: function(snapshotId, containerId, pageId, widgetId, widgetState, pageType) {
					var qs = {
						pageType: pageType
					};
					return containersHttp.post(getUrl(containerId + '/snapshots/' + snapshotId + '/pages/' + pageId + '/widgets/' + widgetId + '/state'), widgetState, { params: qs })
						.then(function(result) {
							if (result && result.data && result.data.widgetId && result.data.data) {
								rsState.setCachedState(result.data.widgetId, pageId, containerId, result.data.data, snapshotId);
							}
							return result;
						})
						.then(getResultSuccess)
						.then(function(result) {
							editEvents.log(pageType);
							return result;
						});
				},
				flush: function(blocking) {
					containersSaveQueue.saveNow(!!blocking);
				}
			};
		}
	]);
})(angular.module('ripsaw'));

(function(module) {
	'use strict';

	module.factory('rsSourceMapsV2', [
		'rsFieldsetsV2.internal.sourceMaps',
		function(sourceMapsAPI)
		{
			function get() {
				return sourceMapsAPI.get.apply(sourceMapsAPI, arguments).then(returnResponseData);
			}

			function create() {
				return sourceMapsAPI.create.apply(sourceMapsAPI, arguments).then(returnResponseData);
			}

			function update() {
				return sourceMapsAPI.update.apply(sourceMapsAPI, arguments).then(returnResponseData);
			}

			function del() {
				return sourceMapsAPI['delete'].apply(sourceMapsAPI, arguments).then(returnResponseData);
			}

			function getById() {
				return sourceMapsAPI.getById.apply(sourceMapsAPI, arguments).then(returnResponseData);
			}

			function returnResponseData(response) {
				return response.data;
			}

			var service = {
				get: get,
				create: create,
				update: update,
				'delete': del,
				getById: getById
			};

			return service;

		}
	]);
})(angular.module('ripsaw'));
/**
 * TODO: multiple successive calls to saveState could potentially result in a race condition, depending on the order in which
 * those requests are actually handles by the server (network hiccups, retries, etc);
 */
(function(module) {
	'use strict';
	module.factory('rsState', [
		'$q',
		'containersHttp',
		'rsEnvironment',
		'rsEditEvents',
		'_rsContainersSaveQueue',
		'_rsCacheUtil',
		'isTemplateContainer',
		'rsConfig',
		'routeTypes',
		function($q, containersHttp, env, editEvents, containersSaveQueue, utils, isTemplateContainer, rsConfig, routeTypes) {

			function getBaseUrl(pageId, containerId, snapshotId) {
				return rsConfig.getRoute(routeTypes.CONTAINERS) + '/' + containerId + (snapshotId ? ('/snapshots/' + snapshotId) : '') + '/pages/' + pageId;
			}

			function getWidgetStateUrl(widgetId, pageId, containerId, snapshotId) {
				return getBaseUrl(pageId, containerId, snapshotId) + '/widgets/' + widgetId + '/state';
			}

			function getPageStateUrl(pageId, containerId, snapshotId) {
				return getBaseUrl(pageId, containerId, snapshotId) + '/widgets/state';
			}

			function getWidgetStatePageUrl(widgetId, pageId, containerId) {
				return getBaseUrl(pageId, containerId) + '/widgets/' + widgetId + '/operations/move';
			}

			function getResultError(result) {
				var deferred = $q.defer();
				deferred.reject(result);
				return deferred.promise;
			}

			var networkCache = {};
			var dataCache = {};

			function saveStateSuccess(result) {
				return result.privateData;
			}

			function saveConfigSuccess(result) {
				return result.sharedData || {};
			}

			function getData(widgetId, pageId, containerId, pageType, optionalSnapshotId) {
				var key = buildKey(widgetId, pageId, containerId, optionalSnapshotId);
				if (dataCache[key]) {
					return $q.when(dataCache[key]);
				} else if (networkCache[key]) {
					return networkCache[key].then(function () {
						// dataCache will be set by time this is hit
						return dataCache[key];
					});
				} else {
					var qs = {
						pageType: pageType
					};
					networkCache[key] = containersHttp.get(getWidgetStateUrl(widgetId, pageId, containerId, optionalSnapshotId), { params: qs }).then(function (result) {
						var data = (result && result.data && result.data.data) || {};
						dataCache[key] = {
							sharedData: data.sharedData || {},
							privateData: data.privateData || {}
						};
						return dataCache[key];
					}, getResultError);
					return networkCache[key];
				}
			}

			// Will make one netwrok request for whole page
			function getDataByPage(widgetId, pageId, containerId, pageType, optionalSnapshotId) {
				var keyWidget = buildKey(widgetId, pageId, containerId, optionalSnapshotId);
				var keyPage = buildKey('', pageId, containerId, optionalSnapshotId);
				if (dataCache[keyWidget]) {
					return $q.when(dataCache[keyWidget]);
				} else if (networkCache[keyPage]) {
					return networkCache[keyPage].then(function () {
						// should  be in the dataCache, or will make individual widget call
						return getData(widgetId, pageId, containerId, pageType, optionalSnapshotId);
					});
				} else {
					var qs = {
						pageType: pageType
					};
					networkCache[keyPage] = containersHttp.get(getPageStateUrl(pageId, containerId, optionalSnapshotId), { params: qs }).then(function (result) {
						var data = (result && result.data) || {};
						_.forEach(data, function (state, wid) {
							dataCache[buildKey(wid, pageId, containerId, optionalSnapshotId)] = {
								sharedData: state.sharedData || {},
								privateData: state.privateData || {}
							};
						});
						// return the data for the widget that made the call, should be in cache
						return getData(widgetId, pageId, containerId, pageType, optionalSnapshotId);
					}, getResultError);
					return networkCache[keyPage];
				}
			}

			function buildKey(widgetId, pageId, containerId, snapshotId) {
				if (snapshotId) {
					return utils.buildKey(widgetId, pageId, containerId, snapshotId);
				}
				return utils.buildKey(widgetId, pageId, containerId);
			}

			var
				LOAD_ALL_STATE_DATA = 'LOAD_ALL_STATE_DATA',	// really load state by page, poor name, better alias below
				LOAD_STATE_BY_PAGE = LOAD_ALL_STATE_DATA,		// better name for load all state data
				LOAD_STATE_BY_WIDGET = 'LOAD_STATE_BY_WIDGET';	// strategy to load state by widget
			var stateLoadStrategy;

			function getLoadFunc () {
				return stateLoadStrategy === LOAD_STATE_BY_WIDGET ? getData: getDataByPage;
			}

			return {
				LOAD_ALL_STATE_DATA: LOAD_ALL_STATE_DATA,
				LOAD_STATE_BY_PAGE: LOAD_ALL_STATE_DATA,
				LOAD_STATE_BY_WIDGET: LOAD_STATE_BY_WIDGET,
				setLoadStrategy: function (strategy) {
					if (strategy === LOAD_STATE_BY_PAGE || strategy === LOAD_STATE_BY_WIDGET) {
						stateLoadStrategy = strategy;
						return true;
					}
					window.console && console.error && console.error('rsState: unrecognized load strategy');
					return false;
				},
				setCachedState: function (widgetId, pageId, containerId, state, optionalSnapshotId) {
					var key = buildKey(widgetId, pageId, containerId, optionalSnapshotId);
					dataCache[key] = state;
				},
				getState: function(widgetId, pageId, containerId, pageType, optionalSnapshotId) {
					return getLoadFunc()(widgetId, pageId, containerId, pageType, optionalSnapshotId).then(function (data) {
						return _.cloneDeep(data.privateData);
					});
				},
				saveState: function(widgetId, pageId, containerId, stateData, pageType, optionalSnapshotId) {
					var key = buildKey(widgetId, pageId, containerId, optionalSnapshotId);
					if (!env.get('editing')) {
						return $q.reject(new Error('Tried to call saveWidgetState() with editing disabled!'));
					}

					if (isTemplateContainer(containerId)) {
						return $q.when(stateData);
					}

					dataCache[key] = dataCache[key] || {sharedData: {}};
					dataCache[key].privateData = _.cloneDeep(stateData) || {};

					var body = {
						containerId: containerId,
						pageId: pageId,
						widgetId: widgetId,
						data: dataCache[key]
					};
					var qs = {
						pageType: pageType
					};

					return containersSaveQueue.queuePut(widgetId, getWidgetStateUrl(widgetId, pageId, containerId, optionalSnapshotId), body, { params: qs })
						.then(saveStateSuccess, getResultError)
						.then(function(result) {
							editEvents.log(pageType);
							return result;
						});
				},
				getConfig: function(widgetId, pageId, containerId, pageType, optionalSnapshotId) {
					return getLoadFunc()(widgetId, pageId, containerId, pageType, optionalSnapshotId).then(function (data) {
						return _.cloneDeep(data.sharedData);
					});
				},
				saveConfig: function(widgetId, pageId, containerId, configData, pageType, optionalSnapshotId) {
					var key = buildKey(widgetId, pageId, containerId, optionalSnapshotId);
					if (!env.get('editing')) {
						return $q.reject(new Error('Tried to call saveConfig() with editing disabled!'));
					}

					if (isTemplateContainer(containerId)) {
						return $q.when(configData);
					}

					dataCache[key] = dataCache[key] || {privateData: {}};
					dataCache[key].sharedData = _.cloneDeep(configData) || {};

					var body = {
						containerId: containerId,
						pageId: pageId,
						widgetId: widgetId,
						data: dataCache[key]
					};
					var qs = {
						pageType: pageType
					};

					return containersSaveQueue.queuePut(widgetId, getWidgetStateUrl(widgetId, pageId, containerId, optionalSnapshotId), body, { params: qs })
						.then(saveConfigSuccess, getResultError)
						.then(function(result) {
							editEvents.log(pageType);
							return result;
						});
				},

				updateWidgetStatePage: function(widgetId, oldPageId, newPageId, containerId, pageType) {
					if (!env.get('editing')) {
						return $q.reject(new Error('Tried to call updateWidgetStatePage() with editing disabled!'));
					}
					if (isTemplateContainer(containerId)) {
						return $q.reject(new Error('updateWidgetStatePage does not support template container!'));
					}

					return getData(widgetId, oldPageId, containerId, pageType).then(function(data) {
						var key = buildKey(widgetId, newPageId, containerId);
						dataCache[key] = _.cloneDeep(data);
						var qs = {
							newPid: newPageId,
							pageType: pageType
						};
						var url = getWidgetStatePageUrl(widgetId, oldPageId, containerId);
						return containersSaveQueue.queuePut(widgetId, url, {}, { params: qs })
							.then(function(result) {
								editEvents.log(pageType);
								return result;
							}).catch(function(err) {
								return getResultError(err);
							});
					});
				},

				flush: function(blocking) {
					containersSaveQueue.saveNow(!!blocking);
				},
				clearCache: function() {
					dataCache = {};
					networkCache = {};
				}
			};
		}
	]);
})(angular.module('ripsaw'));

(function (app) {
	'use strict';
	app.factory('rsSurveys', [
		'$http',
		'rsConfig',
		'routeTypes',
		function ($http, rsConfig, routeTypes) {
			var service = {};
			var baseRipsawServerUrl = rsConfig.getRoute(routeTypes.RIPSAW_SERVER_SURVEYS);
			var NOT_DELETED_FLAG = '0000-00-00 00:00:00';
			var QUESTION_ELEMENT_TYPE = 'Question';
			var TRASH_BLOCK_TYPE = 'Trash';

			angular.extend(service, {
				getAll: getAll,
				getSurveyDef: getSurveyDef,
				getQuestionsForSurvey: getQuestionsForSurvey
			});

			return service;

			function getBaseUrl() {
				return rsConfig.getRoute(routeTypes.SURVEYS);
			}

			function getAll() {
				return $http.get(baseRipsawServerUrl, { cache: true })
					.then(function (response) {
						return response.data;
					});
			}

			function getSurveyDef(surveyId) {
				validateSurveyId(surveyId);
				var url = getBaseUrl() + '/' + surveyId;
				return $http.get(url, { cache: true })
					.then(function (response) {
						var surveyDefinition = response.data;

						// Transformation for Ripsaw Server backwards compatibility
						surveyDefinition.Questions = getActiveQuestions(surveyDefinition);
						surveyDefinition.QuestionCount = parseInt(surveyDefinition.QuestionCount);
						surveyDefinition.Deleted = getDeletionDate(surveyDefinition.Deleted);
						return surveyDefinition;
					});
			}

			function validateSurveyId(surveyId) {
				if (!_.isString(surveyId) || _.isEmpty(surveyId)) {
					throw new TypeError('A survey ID must be provided.');
				}
			}

			function getActiveQuestions(surveyDefinition) {
				var questionsInTrash = getQuestionsInTrash(surveyDefinition);
				var questionsAsArray = _.values(surveyDefinition.Questions);

				return _.filter(questionsAsArray, function (question) {
					return questionsInTrash.indexOf(question.QuestionID) < 0;
				});

			}

			function getDeletionDate(deletedDate) {
				return deletedDate === undefined ? NOT_DELETED_FLAG : deletedDate;
			}

			function getQuestionsInTrash(surveyDefinition) {
				var trashBlock = getTrashBlock(surveyDefinition);
				if (trashBlock && trashBlock.BlockElements) {
					return _.chain(trashBlock.BlockElements)
						.filter(function (element) {
							return element && element.Type === QUESTION_ELEMENT_TYPE;
						})
						.map(function (element) {
							return element && element.QuestionID;
						})
						.value();
				} else {
					return [];
				}
			}

			function getTrashBlock(surveyDefinition) {
				return _.chain(surveyDefinition.Blocks)
					.values()
					.filter(function (block) {
						return block.Type === TRASH_BLOCK_TYPE;
					})
					.value()[0];
			}

			function getQuestionsForSurvey(surveyId) {
				return getSurveyDef(surveyId)
					.then(function (surveyDefinition) {
						return surveyDefinition.Questions;
					});
			}
		}
	]);
})(angular.module('ripsaw'));

(function() {
	'use strict';

	var widgetCoreModule = angular.module('ripsaw');
	widgetCoreModule.factory('rsWidgets', [
		'$rootScope',
		'$compile',
		'$templateCache',
		'$injector',
		'rsState',
		'rsEnvironment',
		'_rsRegistry',
		'_rsCacheUtil',
		function($rootScope, $compile, $templateCache, $injector, state, env, registry, utils)
		{
			var widgetScopes = {};

			var service = {
				LOAD_ALL_META_DATA: registry.LOAD_ALL_META_DATA,
				LOAD_META_DATA_BY_WIDGET: registry.LOAD_META_DATA_BY_WIDGET,
				setLoadStrategy: function (strategy) {
					registry.setStrategy(strategy);
				},
				getWidgetScope: getWidgetScope,
				loadBody: function(name, widgetId, element, pageType, opt_pageId, opt_containerId, opt_snapshotId) {
					var pageId = opt_pageId || env.get('pageId');
					var containerId = opt_containerId || env.get('containerId');
					var snapshotId = opt_snapshotId || env.get('containerSnapshotId');
					return registry.ensureWidget(name).then(function(meta) {
						var scope = getWidgetScope(widgetId, pageId, containerId, element, meta, pageType, snapshotId);
						enableEventListeners(widgetId, element, scope);
						ensureDirective(name, 'body');

						buildDirective(element, name + '.directives.body', name.replace('.', '-'), scope);

						return meta;
					});
				},
				loadOptions: function(name, widgetId, element, pageType, opt_pageId, opt_containerId, opt_snapshotId) {
					var pageId = opt_pageId || env.get('pageId');
					var containerId = opt_containerId || env.get('containerId');
					var snapshotId = opt_snapshotId || env.get('containerSnapshotId');
					return registry.ensureWidget(name).then(function(meta) {
						var scope = getWidgetScope(widgetId, pageId, containerId, element, meta, pageType, snapshotId);
						ensureDirective(name, 'options');

						buildDirective(element, name + '.directives.options', name.replace('.', '-'), scope);

						return meta;
					});
				},
				ensureDependency: function(type) {
					return registry.ensureDependency(type);
				},
				resolveDependency: function(type) {
					return registry.resolveDependency(type);
				},
				getWidgetTypeMetaData: function(type) {
					return registry.ensureWidget(type);
				},
				getWidgets: function(tags) {
					return registry.getWidgets(tags);
				},
				unload: function(widgetId, opt_pageId, opt_containerId, opt_snapshotId) {
					var pageId = opt_pageId || env.get('pageId');
					var containerId = opt_containerId || env.get('containerId');
					var snapshotId = opt_snapshotId || env.get('containerSnapshotId');
					var key = snapshotId ? utils.buildKey(widgetId, pageId, containerId, snapshotId) : utils.buildKey(widgetId, pageId, containerId);
					delete widgetScopes[key];
				},
				clearScopeCache: function () {
					widgetScopes = {};
					return true;
				},
				clearScopeCacheForContainer: function (containerId) {
					if (!containerId) {
						return false;
					}
					var deleteKey = utils.buildKey(containerId);

					// clear all the cached scope corresponding to the key
					widgetScopes = _.omit(widgetScopes, function (scope, key) {
						return key.indexOf(deleteKey) !== -1;
					});

					return true;
				},
				clearScopeCacheForPage: function (containerId, pageId) {
					if (!containerId || !pageId) {
						return false;
					}

					var deleteKey = utils.buildKey(pageId, containerId);

					// clear all the cached scope corresponding to the key
					widgetScopes = _.omit(widgetScopes, function (scope, key) {
						return key.indexOf(deleteKey) !== -1;
					});

					return true;
				}
			};

			/*
				Note: We append the directive to the DOM before compiling
				because some directives need to be on the DOM to initialize
				correctly.
				(e.g. qswitch generates its size based on its width in the DOM)
			*/
			function buildDirective(element, name, css, scope) {
				var html = '<div class="widget-contents ' + css + '" style="height:100%" ' + name + '></div>';
				var elem = angular.element(html);
				element.append(elem);

				var ret = $compile(elem)(scope);

				return ret;
			}

			function ensureDirective(name, type)
			{
				var directiveName = name + '.directives.' + type;
				if (!$injector.has(directiveName))
				{
					var templatePath = name.replace('.', '/') + '/templates/' + type + '.html';
					var def = {
						template: $templateCache.get(templatePath)
					};

					var controller = name + '.controllers.main';
					if (type === 'body') {
						def.controller = controller;
					}
					else {
						def.require = controller;
					}

					var widgetsModule = angular.module('ripsaw.widgets');

					widgetsModule.directive(directiveName, [ function() {
						return def;
					}]);
				}
			}

			function getWidgetScope(widgetId, pageId, containerId, element, meta, pageType, opt_snapshotId) {
				var key = opt_snapshotId ? utils.buildKey(widgetId, pageId, containerId, opt_snapshotId) : utils.buildKey(widgetId, pageId, containerId);
				if (!widgetScopes[key]) {
					var scope = $rootScope.$new();
					scope.$on('$destroy', function() {
						delete widgetScopes[key];
					});
					var noop = function() {};

					widgetScopes[key] = scope;

					scope.ripsaw = {
						BASE_URL: registry.getResourceUrl(meta, ''),
						widgetId: widgetId,
						pageId: pageId,
						containerId: containerId,
						widgetType: meta.author + '.' + meta.name,
						getSavedState: function() {
							return state.getState(widgetId, pageId, containerId, pageType, opt_snapshotId);
						},
						saveState: function(stateData) {
							return state.saveState(widgetId, pageId, containerId, stateData, pageType, opt_snapshotId);
						},
						getSavedConfig: function() {
							return state.getConfig(widgetId, pageId, containerId, pageType, opt_snapshotId);
						},
						saveConfig: function(configData) {
							return state.saveConfig(widgetId, pageId, containerId, configData, pageType, opt_snapshotId);
						},
						isEditingEnabled: function() {
							return !!env.get('editing');
						},
						isMobile: function()
						{
							return !!env.get('mobileMode');
						},
						isSelected: function() {
							return env.get('selectedWidgetId') === widgetId;
						},
						onEditing: noop,
						onViewing: noop,
						onEditStateChanged: noop,
						onEditToViewing: noop,
						onSelected: noop,
						onUnselected: noop,
						onSelectionChanged: noop,
						onResizing: noop,
						onResized: noop,
						onDragged: noop,
						onFiltersChanged: noop,
						onMobileModeChanged: noop
					};
				}

				return widgetScopes[key];
			}

			function enableEventListeners(widgetId, element, scope)
			{
				var bodyScope = element.scope();
				bodyScope.$on('ripsaw.widgets.editing', editingHandle);
				bodyScope.$on('ripsaw.widgets.viewing', viewingHandle);
				bodyScope.$on('ripsaw.widgets.editToViewing', editToViewingHandle);
				bodyScope.$on('ripsaw.widgets.resizing', resizingHandle);
				bodyScope.$on('ripsaw.widgets.resized', resizedHandle);
				bodyScope.$on('ripsaw.widgets.filtersChanged', filterChangedHandle);
				bodyScope.$on('ripsaw.widgets.mobileModeChanged', mobileModeChangedHandle);

				bodyScope.$on('ripsaw.widgets.' + widgetId + '.selected', selectedHandle);
				bodyScope.$on('ripsaw.widgets.' + widgetId + '.unselected', unselectedHandle);
				bodyScope.$on('ripsaw.widgets.' + widgetId + '.resizing', resizingHandle);
				bodyScope.$on('ripsaw.widgets.' + widgetId + '.resized', resizedHandle);
				bodyScope.$on('ripsaw.widgets.' + widgetId + '.dragged', draggedHandle);

				function editingHandle() {
					scope.ripsaw.onEditing(true);
					scope.ripsaw.onEditStateChanged(true);
				}

				function viewingHandle() {
					scope.ripsaw.onViewing(true);
					scope.ripsaw.onEditStateChanged(false);
				}

				function editToViewingHandle() {
					scope.ripsaw.onEditToViewing();
				}

				function resizingHandle() {
					scope.ripsaw.onResizing(getWidgetSize());
				}

				function resizedHandle() {
					scope.ripsaw.onResized(getWidgetSize());
				}

				function draggedHandle() {
					scope.ripsaw.onDragged();
				}

				function filterChangedHandle() {
					scope.ripsaw.onFiltersChanged(env.get('pageFilterDefinitions'));
				}

				function mobileModeChangedHandle(evt, isMobile) {
					scope.ripsaw.onMobileModeChanged(isMobile);
				}

				function selectedHandle() {
					scope.ripsaw.onSelected(true);
					scope.ripsaw.onSelectionChanged(true);
				}

				function unselectedHandle() {
					scope.ripsaw.onUnselected(true);
					scope.ripsaw.onSelectionChanged(false);
				}

				function getWidgetSize() {
					var innerElement = window.jQuery(element).find('.widget-contents')[0];
					return {
						width: innerElement && innerElement.clientWidth || 0,
						height: innerElement && innerElement.clientHeight || 0
					};
				}
			}

			return service;
		}
	]);
})();

/**
*	ActiveRequestCache.js
*	Helper service to synchronize data requests
*
*	Takes a tagged release and cancels any pending requests with the same tag
*/

(function() {
	'use strict';

	angular.module('ripsaw').service('_rsActiveRequestCache', [
		function() {
			var existingRequests = {};

			function setActiveRequest(request, tag) {
				// If this request already exists, abort the existing request and add this one to the cache
				var oldRequest = existingRequests[tag];
				// Don't abort the current request in case we got a cache hit
				if (oldRequest && _.isFunction(oldRequest.abort) && oldRequest.requestId !== request.requestId) {
					oldRequest.abort();
				}
				existingRequests[tag] = request;
			}

			function clearRequests() {
				// Cancel all pending requests
				_.forEach(existingRequests, function(existingRequest) {
					existingRequest.abort();
				});

				// Clear the cache
				existingRequests = {};
			}

			return {
				setActiveRequest: setActiveRequest,
				clearRequests: clearRequests
			};
		}
	]);
})();

/**
*	Utility to help with cache related operations
*/

(function(module) {
	'use strict';

	module.service('_rsCacheUtil', [
		function() {

			// Joins together all the arguments with a - in between
			function buildKey() {
				var args = Array.prototype.slice.call(arguments); //Get args as an array
				return args.join('-');
			}

			return {
				buildKey: buildKey
			};
		}
	]);
})(angular.module('ripsaw'));
(function(module) {
	'use strict';

	module.factory('rsFieldsetsV2.internal.commonUtils', [
		'rsEnvironment',
		function(env) {

			function getSnapshotId(requestingFieldsetId) {
				return env.get('fieldSetId') === requestingFieldsetId ?
					env.get('fieldsetSnapshotId') :
					null;
			}

			function getOrgHierarchyId(requestingFieldsetId) {
				return env.get('fieldSetId') === requestingFieldsetId ?
					env.get('activeOrgHierarchyId') :
					null;
			}

			return {
				getSnapshotId: getSnapshotId,
				getOrgHierarchyId: getOrgHierarchyId
			};
		}
	]);
})(angular.module('ripsaw'));
(function (module) {
	'use strict';
	module.factory('containersHttp', [
		'_HttpHandler',
		'rsContainersRetryConfig',
		'_rsTranslations',
		function (
			HttpHandler,
			rsContainersRetryConfig,
			rsTranslations
		) {
			return new HttpHandler(rsContainersRetryConfig.containersControlOptions, rsTranslations.getTranslationConfig());
		}
	]);
})(angular.module('ripsaw'));

/* @global JSON */
(function(module) {
	'use strict';
	module.factory('_rsContainersSaveQueue', [
		'$q',
		'$http',
		'containersHttp',
		'$timeout',
		'rsEnvironment',
		function($q, $http, containersHttp, $timeout, env) {

			var queue = {};
			var defaultDelay = 3;
			var timer = 0;

			/*
			 * Shamelessly stollen from angularjs 1.3
			 * https://github.com/angular/angular.js/blob/master/src/Angular.js#L1128
			 */
			function isWindow(obj) {
				return obj && obj.window === obj;
			}
			function isScope(obj) {
				return obj && obj.$evalAsync && obj.$watch;
			}
			function toJsonReplacer(key, value) {
				var val = value;

				if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
					val = undefined;
				} else if (isWindow(value)) {
					val = '$WINDOW';
				} else if (value &&  document === value) {
					val = '$DOCUMENT';
				} else if (isScope(value)) {
					val = '$SCOPE';
				}

				return val;
			}

			function isNumeric(n) {
				return !isNaN(parseFloat(n)) && isFinite(n);
			}

			function setTimer(opt_time) {
				$timeout.cancel(timer);
				var delay;
				if (isNumeric(opt_time)) {
					delay = opt_time;
				} else if (isNumeric(env.get('rsSaveQueueTimeSec'))) {
					delay = env.get('rsSaveQueueTimeSec');
				} else {
					delay = defaultDelay;
				}
				timer = $timeout(execute, delay * 1000);
			}

			function execute(opt_blocking) {
				for (var id in queue) {
					if (queue.hasOwnProperty(id)) {
						executeRequest(queue[id], opt_blocking);
					}
				}

				queue = {};
			}

			function getXsrfCookieValue() {
				var cookieArray = document.cookie.split(';');
				var index;
				var cookieValue = '';

				angular.forEach(cookieArray, function(cookie) {
					index = cookie.indexOf('=');
					var substring = cookie.substring(0, index).trim();
					if (index > 0) {
						if (decodeURIComponent(substring) === $http.defaults.xsrfCookieName) {
							cookieValue = decodeURIComponent(cookie.substring(index+1));
						}
					}
				});
				return cookieValue;
			}

			function executeRequest(request, opt_blocking) {
				if (opt_blocking) {
					var headers = {};
					var xsrfCookieValue = getXsrfCookieValue();

					if (xsrfCookieValue) {
						var xsrfHeaderName = $http.defaults.xsrfHeaderName;
						headers[xsrfHeaderName] = xsrfCookieValue;
					}

					var req = {
						async: false,
						type: request.config.method,
						url: request.config.url,
						headers: headers,
						contentType: 'application/json',
						success: request.deferred.resolve,
						error: request.deferred.reject
					};

					if (request.config.data) {
						req.data = JSON.stringify(request.config.data, toJsonReplacer);
					}

					if (request.config.params) {
						req.url = (req.url.indexOf('?') >= 0 ? '&' : '?') + window.jQuery.param(request.config.params);
					}

					window.jQuery.ajax(req);
				}
				else {
					// We have to convert the data object to JSON manually because $http uses angular.toJson which strips out any '$' keys as of Angular v1.2
					if (request.config.data && typeof request.config.data !== 'string') {
						request.config.data = JSON.stringify(request.config.data, toJsonReplacer);
					}
					var method = request.config.method;
					var url = request.config.url;
					var data = request.config.data;
					var config = request.config;
					var httpResultPromise;

					httpResultPromise = containersHttp[method](url, data, config);

					httpResultPromise
						.then(function (response) {
							request.deferred.resolve(response.data);
						}).catch(function (err) {
							request.deferred.reject(err);
						});
				}
			}

			return {
				queue: function (id, method, url, config, opt_delay) {
					var deferred;
					if (queue[id]) {
						deferred = queue[id].deferred;
					}
					else {
						deferred = $q.defer();
					}

					config = config || {};
					config.method = method;
					config.url = url;

					queue[id] = {
						config: config,
						deferred: deferred
					};

					setTimer(opt_delay);

					return deferred.promise;
				},
				queuePut: function(id, url, data, opt_config, opt_delay) {
					var config = opt_config || {};
					config.data = data;
					return this.queue(id, 'put', url, config, opt_delay);
				},
				queuePatch: function(id, url, data, opt_config, opt_delay) {
					var config = opt_config || {};
					config.data = data;
					return this.queue(id, 'patch', url, config, opt_delay);
				},
				saveNow: function(opt_blocking) {
					execute(opt_blocking);
					clearTimeout(timer);
				},
				cancelSave: function(id) {
					delete queue[id];
				}
			};
		}
	]);
})(angular.module('ripsaw'));

(function (module) {
	'use strict';
	module.factory('fieldsetsHttp', [
		'_HttpHandler',
		'rsFieldsetRetryConfig',
		function (
			HttpHandler,
			rsFieldsetRetryConfig
		) {
			return new HttpHandler(rsFieldsetRetryConfig.fieldsetControlOptions);
		}
	]);
})(angular.module('ripsaw'));

(function(module) {
	'use strict';

	module.factory('rsFieldsetsV2.internal.aggregates', [
		'$q',
		'$timeout',
		'fieldsetsHttp',
		'_rsActiveRequestCache',
		'rsFieldsetsV2.internal.commonUtils',
		'rsConfig',
		'routeTypes',
		'publishingConstants',
		'rsPublishing',
		function($q, $timeout, fieldsetsHttp, activeRequestCache, commonUtils, rsConfig, routeTypes, publishingConstants, rsPublishing) {
			var MAXIMUM_BACKOFF_DELAY_MS = 3000;

			var service = {
				getAggregate: getAggregate,
				getAggregateAsync: getAggregateAsync,
				getWordCount: getWordCount
			};

			function getBaseUrl() {
				return rsConfig.getRoute(routeTypes.FIELDSETS);
			}

			function _getQueryParams(requestOptions, fieldSetId){
				var queryParams = requestOptions.qs || {};
				queryParams[publishingConstants.PARAMETER] = requestOptions[publishingConstants.PARAMETER];
				if (!queryParams[publishingConstants.PARAMETER] || 
					(queryParams[publishingConstants.PARAMETER] === publishingConstants.UNPUBLISHED && 
						rsPublishing.isFieldsetPublishingV2Enabled())) {
					queryParams.snapshotId = requestOptions.snapshotId || commonUtils.getSnapshotId(fieldSetId);
				}
				queryParams.orgHierarchyId = requestOptions.orgHierarchyId || commonUtils.getOrgHierarchyId(fieldSetId);
				return queryParams;
			}

			function getAggregate(fieldSetId, metrics, breakouts, filter, requestOptions, controlOptions) {
				requestOptions = requestOptions || {};
				if (!fieldSetId)
				{
					return $q.reject(new Error('Required parameter "fieldsetId" is undefined'));
				}

				var aggregateUrl = getBaseUrl() + '/' + fieldSetId + '/aggregate';

				var body = {
					metrics: metrics
				};
				if (breakouts)
				{
					body.breakouts = breakouts;
				}
				// DFS aggregate requests always require a `filter`` property: https://qualtrics.atlassian.net/browse/EXP-5305
				body.filter = filter || {};
				if (requestOptions.weighted === true)
				{
					body.weighted = true;
				}
				if (requestOptions.timezone) {
					body.timezone = requestOptions.timezone;
				}
				if (requestOptions.customPeriods) {
					body.shiftedPeriods = requestOptions.customPeriods;
				}

				var config = {
					json: true,
					params: _getQueryParams(requestOptions, fieldSetId)
				};

				var useCache = (typeof requestOptions.useCache !== 'undefined') ? requestOptions.useCache : true;

				// If a requestTag is provided, cancel any old requests with that requestTag
				var request = fieldsetsHttp.post(aggregateUrl, body, config, useCache, controlOptions);
				if (activeRequestCache && requestOptions.requestTag) {
					activeRequestCache.setActiveRequest(request, requestOptions.requestTag);
				}
				return request;
			}

			/**
			 * Polls the async aggregate API to retrieve the results of the aggregate calculation
			 * associated with the provided async token.
			 * @param fieldsetId - The fieldsetId of the fieldset.
			 * @param token - The async token to poll.
			 * @param controlOptions - fieldsetsHttp request configuration.
			 * @param snapshotId - The snapshotId associated with the data request.
			 * @returns {Promise<HttpResponse>}
			 */
			function getAggregateAsync(fieldsetId, token, controlOptions, snapshotId) {
				var initialBackoffMs = 10;
				return _pollAggregateAsync(fieldsetId, token, initialBackoffMs, false, controlOptions, snapshotId);
			}

			function _pollAggregateAsync(fieldsetId, token, backoff, shouldDelayRequest, controlOptions, snapshotId) {
				var url = getBaseUrl() + '/' + fieldsetId + '/aggregate/async';
				var backoffWithJitter = 0;
				if (shouldDelayRequest) {
					backoffWithJitter = Math.floor(Math.min(backoff, MAXIMUM_BACKOFF_DELAY_MS) * Math.random());
				}
				var requestBody = {
					token: token
				};
				var requestConfig = {
					json: true,
					params: {
						snapshotId: snapshotId
					}
				};
				return $timeout(backoffWithJitter)
					.then(function () {
						return fieldsetsHttp.post(
							url,
							requestBody,
							requestConfig,
							false /** useCache */,
							controlOptions
						);
					})
					.then(function (response) {
						if (response.status === 202) {
							return _pollAggregateAsync(
								fieldsetId,
								token,
								backoff * 2,
								true /** shouldDelayRequest */,
								controlOptions,
								snapshotId
							);
						}
						return response;
					});
			}

			function getWordCount(fieldSetId, fieldId, requestOptions, controlOptions) {
				requestOptions = requestOptions || {};
				if (!fieldSetId || !fieldId)
				{
					var missingParams = [];
					if (!fieldSetId)
					{
						missingParams.push('fieldSetId');
					}
					if (!fieldId)
					{
						missingParams.push('fieldId');
					}
					return $q.reject(new Error('Required parameter(s) undefined: ' + missingParams.toString()));
				}

				var wordCountUrl = getBaseUrl() + '/' + fieldSetId + '/wordcount';

				var validParams = ['stopwords', 'limit', 'filter', 'defaultLanguageCodes', 'timezone', publishingConstants.PARAMETER];
				var body = _.pick(requestOptions, validParams);
				body.fieldId = fieldId;

				if (requestOptions.customPeriods) {
					body.shiftedPeriods = requestOptions.customPeriods;
				}

				var config = {
					json: true,
					params: _getQueryParams(requestOptions, fieldSetId)
				};
				var useCache = (typeof requestOptions.useCache !== 'undefined') ? requestOptions.useCache : true;

				// If a requestTag is provided, cancel any old requests with that requestTag
				var request = fieldsetsHttp.post(wordCountUrl, body, config, useCache, controlOptions);
				if (activeRequestCache && requestOptions.requestTag) {
					activeRequestCache.setActiveRequest(request, requestOptions.requestTag);
				}
				return request;
			}

			return service;
		}
	]);

})(angular.module('ripsaw'));

/*
 * Interfaces with the fieldset decorator CRUD API
 */
(function(module) {
	'use strict';

	module.factory('rsFieldsetsV2.internal.decorators', [
		'fieldsetsHttp',
		'rsConfig',
		'routeTypes',
		function(fieldsetsHttp, rsConfig, routeTypes) {

			function getUrl(fieldsetId, decoratorId) {
				return rsConfig.getRoute(routeTypes.FIELDSET_DEFINITION) + '/' + fieldsetId + '/decorators/' +  decoratorId;
			}

			function extractResponseData(response) {
				return response && response.data || {};
			}

			function handleHttpError(error) {
				console.error('Error making http request for fieldset decorator:', error);
				throw error;
			}

			var service = {
				get: function(fieldsetId, decoratorId, controlOptions) {
					var useCache = true;
					return fieldsetsHttp.get(
						getUrl(fieldsetId, decoratorId),
						undefined,
						useCache,
						controlOptions
					)
						.then(extractResponseData, handleHttpError);
				},
				put: function(fieldsetId, decoratorId, data) {
					return fieldsetsHttp.put(getUrl(fieldsetId, decoratorId), data)
						.then(extractResponseData, handleHttpError);
				},
				post: function(fieldsetId, decoratorId, data) {
					return fieldsetsHttp.post(getUrl(fieldsetId, decoratorId), data)
						.then(extractResponseData, handleHttpError);
				},
				deleteDecorator: function(fieldsetId, decoratorId) {
					return fieldsetsHttp.delete(getUrl(fieldsetId, decoratorId))
						.then(extractResponseData, handleHttpError);
				}
			};

			return service;
		}
	]);
})(angular.module('ripsaw'));

(function(module) {
	'use strict';

	module.factory('rsFieldsetsV2.internal.fieldsets', [
		'$q',
		'fieldsetsHttp',
		'rsEnvironment',
		'rsPublishing',
		'$http',
		'rsConfig',
		'routeTypes',
		'publishingConstants',
		function($q, fieldsetsHttp, environment, rsPublishing, $http, rsConfig, routeTypes, publishingConstants) {
			function getBaseUrl() {
				return rsConfig.getRoute(routeTypes.FIELDSETS);
			}

			function getDefinitionUrl() {
				return rsConfig.getRoute(routeTypes.FIELDSET_DEFINITION) || rsConfig.getRoute(routeTypes.FIELDSETS);
			}

			function shouldUseCache(useCache) {
				return (useCache !== undefined) ? useCache : true;
			}

			function get(requestOptions, controlOptions) {
				requestOptions = requestOptions || {};
				var validParams = ['offset', 'limit', 'include', 'keyName', 'keyValue', 'assumeHasPermission', publishingConstants.PARAMETER];
				// Prepare query parameters
				var params = _.pick(requestOptions, validParams);

				if ((params.keyName && !params.keyValue) || (!params.keyName && params.keyValue))
				{
					return $q.reject(new Error('keyName and keyValue options must be included together'));
				}

				var config = { params: params };
				var useCache = shouldUseCache(requestOptions.useCache);
				return fieldsetsHttp.get(getBaseUrl(), config, useCache, controlOptions);
			}

			function create(fieldset) {
				fieldset = fixFieldSetIdCaseSensitivity(fieldset);
				var fieldSetId = fieldset.fieldSetId;
				var fieldsetUrl = getBaseUrl() + '/' + fieldSetId;
				return validateFieldsetView(fieldset.fieldsetView).then(function() {
					return fieldsetsHttp.post(fieldsetUrl, fieldset)
						.then(function(result) {
							result = result || {};
							result.data = result.data || {};
							result.data.fieldSetId = result.data.fieldSetId || fieldSetId;
							return result;
						});
				});
			}

			function update(fieldset, queryParams) {
				fieldset = fixFieldSetIdCaseSensitivity(fieldset);
				var fieldsetUrl = getBaseUrl() + '/' + fieldset.fieldSetId;
				var config = {
					json: true,
					params: queryParams || {}
				};
				return validateFieldsetView(fieldset.fieldsetView).then(function() {
					return fieldsetsHttp.put(fieldsetUrl, fieldset, config);
				});
			}

			function fixFieldSetIdCaseSensitivity(fieldset) {
				// RE is case-sensitive, requiring "fieldSetId"
				if (fieldset.fieldsetId && !fieldset.fieldSetId)
				{
					fieldset.fieldSetId = fieldset.fieldsetId;
					delete fieldset.fieldsetId;
				}
				return fieldset;
			}

			function del(fieldSetId) {
				var fieldsetUrl = getBaseUrl() + '/' + fieldSetId;
				return fieldsetsHttp.delete(fieldsetUrl);
			}

			function getById(fieldSetId, requestOptions, controlOptions) {
				requestOptions = requestOptions || {};
				var validParams = [ 'useCache', 'include' ,'assumeHasPermission', publishingConstants.PARAMETER ];
				// Prepare query parameters
				var params = _.pick(requestOptions, validParams);
				if (!params[publishingConstants.PARAMETER] && rsPublishing.useUnpublishedFieldset()) {
					params[publishingConstants.PARAMETER] = publishingConstants.UNPUBLISHED;
				}

				var fieldsetUrl = getBaseUrl() + '/' + fieldSetId;
				var config = { params: params };
				var useCache = shouldUseCache(requestOptions.useCache);
				return fieldsetsHttp.get(fieldsetUrl, config, useCache, controlOptions);
			}

			function getVersionsById(fieldSetId, requestOptions, controlOptions) {
				requestOptions = requestOptions || {};
				var validParams = [ 'useCache' ];
				// Prepare query parameters
				var params = _.pick(requestOptions, validParams);

				var fieldsetUrl = getDefinitionUrl() + '/' + fieldSetId + '/suffixes';
				var config = { params: params };
				var useCache = shouldUseCache(requestOptions.useCache);
				return fieldsetsHttp.get(fieldsetUrl, config, useCache, controlOptions);
			}

			function requestHeadById(fieldsetId, requestOptions, controlOptions) {
				requestOptions = requestOptions || {};
				var validParams = [ 'useCache', publishingConstants.PARAMETER ];
				// Prepare query parameters
				var params = _.pick(requestOptions, validParams);

				var fieldsetUrl = getDefinitionUrl() + '/' + fieldsetId;
				var config = { params: params };
				var useCache = shouldUseCache(requestOptions.useCache);
				return fieldsetsHttp.head(fieldsetUrl, config, useCache, controlOptions);
			}

			function validateFieldsetView() {
				return $q.when();
			}

			var AE_MIGRATION_STATUS_HEADER = 'x-ae-migration-status';
			var AE_SUPPORTED_HEADERS = ['FullReadAeNoBackup', 'FullReadAeWithBackup', 'FullAeTriggered'];

			function setAEstatus(fieldSetId) {
				$http.get(getBaseUrl() + '/' + fieldSetId, {})
					.then(function(response) {
						var AEisSupported = isAnalyticsEngineSupported(response);
						environment.set('AEenabled', AEisSupported);
					});
			}

			function isAnalyticsEngineSupported(response) {
				return AE_SUPPORTED_HEADERS.indexOf(response.headers(AE_MIGRATION_STATUS_HEADER)) !== -1;
			}

			var service = {
				get: get,
				create: create,
				update: update,
				'delete': del,
				getById: getById,
				requestHeadById: requestHeadById,
				getVersionsById: getVersionsById,
				setAEstatus: setAEstatus
			};

			return service;
		}
	]);
})(angular.module('ripsaw'));

/*
 * Interfaces with the fieldset weighting CRUD API
 */
(function(module) {
	'use strict';

	module.factory('rsFieldsetsV2.internal.weights', [
		'fieldsetsHttp',
		'rsConfig',
		'routeTypes',
		function(fieldsetsHttp, rsConfig, routeTypes) {

			function getWeightingUrl(fsId) {
				return rsConfig.getRoute(routeTypes.FIELDSETS) + '/' + fsId + '/weights';
			}

			function extractResponseData(response) {
				return response && response.data || {};
			}

			function handleHttpError(err) {
				console.error('Error making http request for fieldset weighting: ', err);
				throw err;
			}

			var service = {
				get: function(fsId) {
					return fieldsetsHttp.get(getWeightingUrl(fsId)).then(extractResponseData, handleHttpError);
				},
				put: function(fsId, weights) {
					return fieldsetsHttp.put(getWeightingUrl(fsId), weights).then(extractResponseData, handleHttpError);
				},
				post: function(fsId, weights) {
					return fieldsetsHttp.post(getWeightingUrl(fsId), weights).then(extractResponseData, handleHttpError);
				},
				'delete': function(fsId) {
					return fieldsetsHttp.delete(getWeightingUrl(fsId)).then(extractResponseData, handleHttpError);
				}
			};

			return service;
		}
	]);
})(angular.module('ripsaw'));

/*
 * Interfaces with the ResponseEngine's progress service
 *
 * The basic idea is that we will make batch requests for polling progress status, rather than
 * making a request for every progress status each time it needs to poll.
 *
 * Eventually, http polling should be replaced with websockets. But for now we need this functionality long
 * sooner than we'd be able to spend the time setting up and testing a full sockets stack.
 *
 * Some things this module does:
 * - makes a single batch poll request for all pending progressIds, rather than doing 15 requests for 15 progressIds
 * - backs off the poll interval after every poll request, if no new progressIds are being tracked (up to a defined max interval)
 * - if new progressIds are wanting to be tracked, it resets the poll interval so that newer progress
 *   requests don't get backed up behind older, slower ones.
 * - if multiple errors occur when trying to poll for progress, this will stop polling to prevent infinite
 *   browser requests on dead/erroring server
 * - it will use promise.notify to give the callers periodic updates about progressId status until it completes
 * - if multiple calls come in for tracking the same progressId, it will Do The Right Thing™ (share a promise)
 */
(function(module) {
	'use strict';

	// these are injected so we can access them in tests
	module.value('rsFieldsets.internal.progress.pendingProgressIds', []);
	module.value('rsFieldsets.internal.progress.timingParams', {
		POLL_BASE_INTERVAL: 2000,
		POLL_BACK_OFF_RATE: 1.5,
		POLL_MAX_DELAY: 30000,
		POLL_MAX_CONSECUTIVE_ERROR_RETRY_COUNT: 3
	});
	module.factory('rsFieldsetProgress',
	[
		'$q',
		'$http',
		'rsFieldsets.internal.progress.pendingProgressIds',
		'rsFieldsets.internal.progress.timingParams',
		'rsConfig',
		'routeTypes',
		function($q, $http, pendingProgressIds, timingParams, rsConfig, routeTypes) {

			var STATE_IDLE = 0;
			var STATE_AWAITING_TIMER = 1;
			var STATE_AWAITING_RESPONSE = 2;
			var STATE_PROCESSING_RESPONSE = 3;

			var PROGRESS_PENDING_STATUSES = [ 'Created', 'Running' ];
			var PROGRESS_SUCCESS_STATUS = 'Finished';

			var currentState = STATE_IDLE;

			var pollErrorCount = 0;
			var pollBackOffMultiplier = 0;
			var promisesForProgress = {};

			var _pollTimeoutRef = null;

			var service = {
				waitForCompletion: function(progressId) {
					if (!progressId)
					{
						return $q.reject(new Error('Called progressService.waitForCompletion without a progress ID'));
					}

					if (!promisesForProgress[progressId])
					{
						promisesForProgress[progressId] = $q.defer();
						pendingProgressIds.push(progressId);

						//reset the back-off multiplier so that new requests don't suffer delay from old requests
						resetBackOff();
						triggerPollTimer(true);
					}

					return promisesForProgress[progressId].promise;
				}
			};

			function getBaseUrl() {
				return rsConfig.getRoute(routeTypes.PROGRESS);
			}

			function makeHttpProgressCall() {
				currentState = STATE_AWAITING_RESPONSE;
				$http.get(getBaseUrl(), { params: { progressIds: pendingProgressIds }})
					.then(function(res) {
						handleHttpResponse(null, res && res.data || {}, false);
					}, function(err) {
						handleHttpResponse(err);
					});
			}

			function handleHttpResponse(err, res) {
				currentState = STATE_PROCESSING_RESPONSE;

				if (err)
				{
					pollErrorCount++;
					if (pollErrorCount >= timingParams.POLL_MAX_CONSECUTIVE_ERROR_RETRY_COUNT)
					{
						//don't retry unless more progressIds are added.
						currentState = STATE_IDLE;
						pollErrorCount = 0;
						console.warn('giving up on progress polling: too many consecutive errors');
						return;
					}
				}
				else
				{
					pollErrorCount = 0;
				}

				//var debugStrings = [];
				_.each(res, function(progress, progressId) {
					if (progress && PROGRESS_PENDING_STATUSES.indexOf(progress.status) !== -1)
					{
						if (promisesForProgress[progressId])
						{
							promisesForProgress[progressId].notify(progress);
						}
					}
					else
					{
						_.remove(pendingProgressIds, function(pId) { return pId === progressId; });

						if (promisesForProgress[progressId])
						{
							if (progress.status === PROGRESS_SUCCESS_STATUS)
							{
								promisesForProgress[progressId].resolve(progress);
							}
							else
							{
								promisesForProgress[progressId].reject(progress);
							}
						}
						else
						{
							console.error('unknown progress id: ' + progressId);
						}
					}
					//debugStrings.push('----> ' + progress.status + ' - progressId: ' + progressId);
				});

				// console.log(debugStrings.join('\n'));

				if (pendingProgressIds.length)
				{
					triggerPollTimer();
				}
				else
				{
					currentState = STATE_IDLE;
					resetBackOff();
				}
			}

			function triggerPollTimer(interruptTimer) {

				if (currentState === STATE_AWAITING_TIMER && interruptTimer)
				{
					// console.log('clearing timeout!');
					clearTimeout(_pollTimeoutRef);
					_pollTimeoutRef = null;
					currentState = STATE_IDLE;
				}

				if (currentState === STATE_IDLE || currentState === STATE_PROCESSING_RESPONSE)
				{
					currentState = STATE_AWAITING_TIMER;

					// exponential backoff on poll intervals to avoid DDoSing or cannibalizing browser connections
					// but respect the max poll delay setting
					var timeoutMs = timingParams.POLL_BASE_INTERVAL * Math.pow(timingParams.POLL_BACK_OFF_RATE, pollBackOffMultiplier);
					timeoutMs = Math.min(timingParams.POLL_MAX_DELAY, timeoutMs);
					_pollTimeoutRef = setTimeout(makeHttpProgressCall, timeoutMs);
					backOff();

					// console.log('waiting ' + timeoutMs/1000 + ' seconds');
				}
			}

			function resetBackOff() {
				pollBackOffMultiplier = 0;
			}

			function backOff() {
				pollBackOffMultiplier++;
			}

			return service;
		}
	]);
})(angular.module('ripsaw'));

(function(module) {
	'use strict';

	module.factory('rsFieldsetsV2.internal.records', [
		'$q',
		'fieldsetsHttp',
		'_rsActiveRequestCache',
		'rsFieldsetsV2.internal.commonUtils',
		'rsConfig',
		'rsPublishing',
		'routeTypes',
		'publishingConstants',
		function($q, fieldsetsHttp, activeRequestCache, commonUtils, rsConfig, rsPublishing, routeTypes, publishingConstants) {

			function getBaseUrl() {
				return rsConfig.getRoute(routeTypes.FIELDSETS);
			}

			function get(fieldSetId, requestOptions, controlOptions) {
				requestOptions = requestOptions || {};
				var validParams = ['offset','limit','filter','fields','sort','timezone', publishingConstants.PARAMETER];
				var body = _.pick(requestOptions, validParams);

				if (requestOptions.customPeriods) {
					body.shiftedPeriods = requestOptions.customPeriods;
				}

				var config = {
					json: true,
					params: {
						snapshotId: requestOptions.snapshotId || commonUtils.getSnapshotId(fieldSetId),
						orgHierarchyId: requestOptions.orgHierarchyId || commonUtils.getOrgHierarchyId(fieldSetId)
					}
				};

				if (rsPublishing.useUnpublishedFieldset()) {
					config.params[publishingConstants.PARAMETER] = publishingConstants.UNPUBLISHED;
					delete config.params.snapshotId;
				}


				var recordsUrl = getBaseUrl() + '/' + fieldSetId + '/records';
				var useCache = (requestOptions.useCache !== undefined) ? requestOptions.useCache : true;

				var request = fieldsetsHttp.post(recordsUrl, body, config, useCache, controlOptions);

				// If tagged, cancel any existing request with that tag
				if (activeRequestCache && requestOptions.requestTag) {
					activeRequestCache.setActiveRequest(request, requestOptions.requestTag);
				}
				return request;
			}

			function updateBatch(fieldSetId, body, queryParams) {
				var recordsUrl = getBaseUrl() + '/' + fieldSetId + '/records';
				var config = {
					json: true,
					params: queryParams || {}
				};
				return fieldsetsHttp.put(recordsUrl, body, config);
			}

			function update(fieldSetId, recordId, record, queryParams) {
				var recordUrl = getBaseUrl() + '/' + fieldSetId + '/record/' + recordId;
				var config = {
					json: true,
					params: queryParams || {}
				};
				return fieldsetsHttp.put(recordUrl, record, config);
			}

			function del(fieldSetId, recordId, requestOptions) {
				requestOptions = requestOptions || {};
				var recordUrl = getBaseUrl() + '/' + fieldSetId + '/record/' + recordId;
				var config = {
					params: requestOptions
				};
				return fieldsetsHttp.delete(recordUrl, config);
			}

			function deleteBatch(fieldSetId, requestOptions) {
				requestOptions = requestOptions || {};
				var recordUrl = getBaseUrl() + '/' + fieldSetId + '/records';
				var config = {
					params: requestOptions
				};
				return fieldsetsHttp.delete(recordUrl, config);
			}

			function revert(fieldSetId, recordId, fieldId, requestOptions) {
				requestOptions = requestOptions || {};
				var recordUrl = getBaseUrl() + '/' + fieldSetId + '/record/' + recordId + '/edits/' + fieldId;
				var config = {
					params: requestOptions
				};
				return fieldsetsHttp.delete(recordUrl, config);
			}

			function getById(fieldSetId, recordId, requestOptions, controlOptions) {
				requestOptions = requestOptions || {};
				var validParams = ['fields', 'assumeHasPermission', publishingConstants.PARAMETER];
				var recordUrl = getBaseUrl() + '/' + fieldSetId + '/record/' + recordId;
				var useCache = (requestOptions.useCache !== undefined) ? requestOptions.useCache : true;
				var newOptions = _.pick(requestOptions, validParams);
				if (rsPublishing.useUnpublishedFieldset()) {
					newOptions[publishingConstants.PARAMETER] = publishingConstants.UNPUBLISHED;
					delete newOptions.snapshotId;
				}
				var config = {
					params: newOptions
				};

				return fieldsetsHttp.get(recordUrl, config, useCache, controlOptions);
			}

			var service = {
				get: get,
				update: update,
				updateBatch: updateBatch,
				'delete': del,
				deleteBatch: deleteBatch,
				revert: revert,
				getById: getById
			};

			return service;
		}
	]);
})(angular.module('ripsaw'));

(function(module) {
	'use strict';

	module.factory('rsFieldsetsV2.internal.sourceMaps', [
		'$q',
		'fieldsetsHttp',
		'rsConfig',
		'routeTypes',
		function($q, fieldsetsHttp, rsConfig, routeTypes)
		{

			function getBaseUrl() {
				return rsConfig.getRoute(routeTypes.FIELDSETS);
			}

			function get(fieldSetId, requestOptions, controlOptions) {
				requestOptions = requestOptions || {};
				var validParams = ['assumeHasPermission'];
				var params = _.pick(requestOptions, validParams);
				var config = { params: params };
				var useCache = (requestOptions.useCache !== undefined) ? requestOptions.useCache : true;
				var sourceMapsUrl = getBaseUrl() + '/' + fieldSetId + '/sourceMaps';
				return fieldsetsHttp.get(sourceMapsUrl, config, useCache, controlOptions);
			}

			function create(fieldSetId, sourceMap) {
				var sourceMapsUrl = getBaseUrl() + '/' + fieldSetId + '/sourceMaps';
				var config = { json: true };
				return fieldsetsHttp.post(sourceMapsUrl, sourceMap, config);
			}

			function update(fieldSetId, sourceMapId, sourceMap, queryParams) {
				var sourceMapsUrl = getBaseUrl() + '/' + fieldSetId + '/sourceMaps/' + sourceMapId;
				var config = {
						json: true,
						params: queryParams || {}
					};
				return fieldsetsHttp.put(sourceMapsUrl, sourceMap, config);
			}

			function del(fieldSetId, sourceMapId) {
				var sourceMapUrl = getBaseUrl() + '/' + fieldSetId + '/sourceMaps/' + sourceMapId;
				return fieldsetsHttp.delete(sourceMapUrl);
			}

			function getById(fieldSetId, sourceMapId, requestOptions, controlOptions) {
				requestOptions = requestOptions || {};
				var validParams = ['assumeHasPermission'];
				var params = _.pick(requestOptions, validParams);
				var config = { params: params };
				var useCache = (requestOptions.useCache !== undefined) ? requestOptions.useCache : true;
				var sourceMapUrl = getBaseUrl() + '/' + fieldSetId + '/sourceMaps/' + sourceMapId;
				return fieldsetsHttp.get(sourceMapUrl, config, useCache, controlOptions);
			}

			var service = {
				get: get,
				create: create,
				update: update,
				delete: del,
				getById: getById
			};

			return service;
		}
	]);
})(angular.module('ripsaw'));

(function (module) {
	'use strict';

	module.factory('httpCache', [
		'$cacheFactory',
		'$q',
		'$timeout',
		'requestAggregator',
		function (
			$cacheFactory,
			$q,
			$timeout,
			Aggregator
		) {
			var cache = $cacheFactory.get('ripsaw.httpcache') || $cacheFactory('ripsaw.httpcache');

			function get(url, config, useCache, controlOptions) {
				return _makeCacheRequest('get', url, config, useCache, controlOptions);
			}

			function head(url, config, useCache, controlOptions) {
				return _makeCacheRequest('head', url, config, useCache, controlOptions);
			}

			function del(url, config, useCache, controlOptions) {
				return _makeCacheRequest('delete', url, config, useCache, controlOptions);
			}

			function jsonp(url, config, useCache, controlOptions) {
				return _makeCacheRequest('jsonp', url, config, useCache, controlOptions);
			}

			function post(url, data, config, useCache, controlOptions) {
				return _makeCacheRequest('post', url, config, useCache, controlOptions, data);
			}

			function put(url, data, config, useCache, controlOptions) {
				return _makeCacheRequest('put', url, config, useCache, controlOptions, data);
			}

			function patch(url, data, config, useCache, controlOptions) {
				return _makeCacheRequest('patch', url, config, useCache, controlOptions, data);
			}

			function cacheRequestWithNoBody(method, url, config, response) {
				_cacheRequest(method, url, config, response);
			}

			function cacheRequestWithBody(method, url, body, config, response) {
				_cacheRequest(method, url, config, response, body);
			}

			function _cacheRequest(method, url, config, response, body) {
				response = $q.when(response);
				var cacheKey = _getCacheKeyForRequest(method, url, config, body);
				cache.put(cacheKey, response);
			}

			function _makeCacheRequest(method, url, config, useCache, controlOptions, body) {
				var cacheKey = _getCacheKeyForRequest(method, url, config, body);
				return _makeCacheRequestHelper(cacheKey, method, url, body, config, useCache, controlOptions);
			}

			function invalidateCache() {
				cache.removeAll();
			}

			function invalidateCacheRequest(method, url, config, body) {
				var cacheKey = _getCacheKeyForRequest(method, url, config, body);
				cache.remove(cacheKey);
			}

			function _getCacheKeyForRequest(method, url, config, body) {
				var cacheKey = method + url;
				if (body) {
					cacheKey += JSON.stringify(body);
				}
				cacheKey += JSON.stringify(config);
				return cacheKey;
			}

			// Helper function to check cache for the request or make the new http request and cache it
			// Returns a request copy with the abort function to cancel the http request
			function _makeCacheRequestHelper(cacheKey, method, url, body, config, useCache, controlOptions) {
				config = config || {};
				controlOptions = controlOptions || {};
				var cachedResult = cache.get(cacheKey);
				var resultPromise;
				if (useCache && cachedResult) {
					resultPromise = cachedResult;
				}
				else {
					var abortFn = _addAbort(config);

					resultPromise = _makeRetryableHttpRequest(cacheKey, method, url, body, config, controlOptions)
						.catch(function (err) {
							cache.remove(cacheKey);
							return $q.reject(err);
						});

					resultPromise.abort = abortFn;
					resultPromise.requestId = _.random(99999);

					cache.put(cacheKey, resultPromise);
				}

				if (controlOptions.noClone) {
					return resultPromise;
				} else {
					var resultPromiseCopy = resultPromise.then(angular.copy);
					resultPromiseCopy.abort = resultPromise.abort; // Add abort to new promise from .then
					resultPromiseCopy.requestId = resultPromise.requestId;
					return resultPromiseCopy;
				}
			}

			function _makeRetryableHttpRequest(cacheKey, method, url, body, config, controlOptions) {
				var remainingRetries = controlOptions.maxRetries;
				var maxDelay = controlOptions.maxDelay;
				var delayTime = controlOptions.initialDelay;

				function makeRequest() {
					return _makeHttpRequest(cacheKey, method, url, body, config, controlOptions.requestAggregator)
						.catch(function (response) {
							if (controlOptions.shouldRetry &&
								controlOptions.shouldRetry(response) &&
								remainingRetries > 0) {
								var delay = delayTime;
								remainingRetries--;
								delayTime *= 2;
								delayTime = delayTime < maxDelay ? delayTime : maxDelay;
								return $timeout(makeRequest, delay);
							}
							return $q.reject(response);
						});
				}

				return makeRequest();
			}

			// Helper function to make the http request and add custom functions to the response
			// Sets an abort function to later cancel the request
			// Sets an error function to remove the request from the cache
			function _makeHttpRequest(cacheKey, method, url, body, config, requestAggregator) {
				config = config || {};
				var http = Aggregator.getHttp(requestAggregator);

				// note: apps are decorating the $http shorthand functions
				// to track RUM metrics, so we can't use the generic $http()
				return body ?
					http[method](url, body, config) :
					http[method](url, config);
			}

			// Add a timeout promise to the $http config
			// Returns a function that will cancel the $http request
			function _addAbort(config) {
				var abortPromise;

				// If the request doens't specify a timeout, add one for aborting the request
				if (!config.timeout) {
					abortPromise = $q.defer();
					config.timeout = abortPromise.promise;
				}
				return function () {
					// Cancel this request
					if (abortPromise) {
						abortPromise.resolve();
					}
				};
			}

			var service = {
				get: get,
				head: head,
				post: post,
				put: put,
				'delete': del,
				patch: patch,
				jsonp: jsonp,
				cacheRequestWithNoBody: cacheRequestWithNoBody,
				cacheRequestWithBody: cacheRequestWithBody,
				invalidateCache: invalidateCache,
				invalidateCacheRequest: invalidateCacheRequest
			};

			return service;
		}
	]);
})(angular.module('ripsaw'));

(function (module) {
	'use strict';
	module.factory('_HttpHandler', [
		'httpCache',
		function (httpCache) {
			function addGlobalConfig(controlOptionsGlobal, controlOptions) {
				return _.extend({}, controlOptionsGlobal, controlOptions);
			}

			function getConfig(defaultConfig, config) {
				return _.merge({}, defaultConfig, config);
			}

			var HttpHandler = function (controlOptionsGlobal, defaultConfig) {
				this.head = function (url, config, useCache, controlOptions) {
					useCache = useCache || false;
					return httpCache.head(url, getConfig(defaultConfig, config), useCache, addGlobalConfig(controlOptionsGlobal, controlOptions));
				};
				this.get = function (url, config, useCache, controlOptions) {
					useCache = useCache || false;
					return httpCache.get(url, getConfig(defaultConfig, config), useCache, addGlobalConfig(controlOptionsGlobal, controlOptions));
				};
				this.post = function (url, data, config, useCache, controlOptions) {
					data = data || {};
					useCache = useCache || false;
					return httpCache.post(url, data, getConfig(defaultConfig, config), useCache, addGlobalConfig(controlOptionsGlobal, controlOptions));
				};
				this.patch = function (url, data, config, useCache, controlOptions) {
					data = data || {};
					useCache = useCache || false;
					return httpCache.patch(url, data, getConfig(defaultConfig, config), useCache, addGlobalConfig(controlOptionsGlobal, controlOptions));
				};
				this.put = function (url, data, config, useCache, controlOptions) {
					data = data || {};
					useCache = useCache || false;
					return httpCache.put(url, data, getConfig(defaultConfig, config), useCache, addGlobalConfig(controlOptionsGlobal, controlOptions));
				};
				this.delete = function (url, config, useCache, controlOptions) {
					useCache = useCache || false;
					return httpCache.delete(url, getConfig(defaultConfig, config), useCache, addGlobalConfig(controlOptionsGlobal, controlOptions));
				};
			};
			return HttpHandler;
		}
	]);
})(angular.module('ripsaw'));

(function(app) {
	'use strict';
	var TEMPLATE_PREFIX = 'template';
	app.factory('isTemplateContainer', function() {
		/**
		 *  We check is the current contaiener Id is a template Container.
		 *  Note: The current method of using prefix matching of template
		 *  may not scale.
		 *
		 * @param {String} containerId Container Id
		 * @returns {Boolean} Is the current containerId a template container.
		 */
		return function(containerId) {
			return containerId && (containerId.indexOf(TEMPLATE_PREFIX) === 0);
		};
	});
})(angular.module('ripsaw'));

'use strict';
angular.module('ripsaw').filter('rsMessage',
	['rsMessages', function(rsMessages) {
		return function(key, opt_values) {
			return rsMessages.getMessage(key, opt_values);
		};
	}
]);

'use strict';

angular.module('ripsaw').value('_rsMessages', {EN: {}});
angular.module('ripsaw').factory('rsMessages', [
	'$cacheFactory',
	'$interpolate',
	'_rsMessages',
	'rsEnvironment',
	'rsLog',
	function ($cacheFactory, $interpolate, messages, env, log) {
		var service = {},
			cache = $cacheFactory('rsMessages');
			// we cache messages here so failed calls to rsMessages
			// won't clog our logs on each digest cycle

		function getMessage(key) {
			if (!key) {
				return '';
			}

			var parts = key.split('.');
			var user = env.get('user');
			var target;

			if (parts.length < 2) {
				throw new Error('Trying to get message with invalid parameter: ' + key);
			}

			if(user && messages[user.language] !== undefined) {
				target = messages[user.language];
			} else if (user && user.language === 'DEV') {
				target = key;
			} else {
				target = messages.EN;
			}

			angular.forEach(parts, function(part) {
				if(target[part] !== undefined) {
					target = target[part];
				} else {
					throw new Error('Message key ' + key + ' does not exist');
				}
			});

			return target;
		}

		service.addMessages = function(value) {
			_.merge(messages, value);
		};

		service.getMessage = function(key, values) {
			values = values || {};

			var msg = cache.get(key);
			if (msg === undefined) {
				try {
					msg = getMessage(key);
				}
				catch (e) {
					log.warn(e.message);
					msg = key.split('.').pop();
				}
				finally {
					cache.put(key, msg);
				}
			}

			return $interpolate(msg)(values);
		};

		return service;
	}

]);

(function(module) {
	'use strict';
	module.factory('pageTypes', function() {
		var USER_PAGE = 'userPages';
		var PUBLIC_PAGE = 'pages';

		return {
			USER_PAGE: USER_PAGE,
			PUBLIC_PAGE: PUBLIC_PAGE
		};
	});
})(angular.module('ripsaw'));
/*
 * Injected in place of $http to proxy all requests through a local endpoint so we can get external resources.
 */
(function(module) {
	'use strict';

	module.factory('_rsProxy',
	[
		'$http',
		'$location',
		'rsConfig',
		'routeTypes',
		function($http, $location, rsConfig, routeTypes) {
			return (function() {
				/* jshint validthis:true */
				var factory = function factory(source)
				{
					var service = function(config) {
						return _handleRequest(config, source);
					};
					window.jQuery.extend(service, serviceFuncs, { _source: source });
					return service;
				};

				var serviceFuncs = {

					// methods
					'delete': function(url, config)
					{
						config = config || {};
						config.url = url;
						config.method = 'DELETE';
						return _handleRequest(config, this._source);
					},
					get: function(url, config)
					{
						config = config || {};
						config.url = url;
						config.method = 'GET';
						return _handleRequest(config, this._source);
					},
					head: function(url, config)
					{
						config = config || {};
						config.url = url;
						config.method = 'HEAD';
						return _handleRequest(config, this._source);
					},
					jsonp: $http.jsonp,
					patch: function(url, data, config)
					{
						config = config || {};
						config.url = url;
						config.data = data;
						config.method = 'PATCH';
						return _handleRequest(config, this._source);
					},
					post: function(url, data, config)
					{
						config = config || {};
						config.url = url;
						config.data = data;
						config.method = 'POST';
						return _handleRequest(config, this._source);
					},
					put: function(url, data, config)
					{
						config = config || {};
						config.url = url;
						config.data = data;
						config.method = 'PUT';
						return _handleRequest(config, this._source);
					},

					// properties
					defaults: $http.defaults,
					pendingRequests: $http.pendingRequests,
					raw: $http // expose the raw $http module so people can make unproxied requests when suitable

				};

				var _handleRequest = function(config, source) {

					var url = config.url;
					var shouldProxy = true;

					if (url.substr(0, 2) === '//') {
						// fill out the protocol
						url = $location.protocol() + ':' + url;
					}
					else if (url.substr(0, 1) === '/') {
						// this is a relative url. don't bother proxying it
						shouldProxy = false;
					}

					var baseConfig = {};
					if (shouldProxy) {
						config.url = rsConfig.getRoute(routeTypes.PROXY);
						baseConfig.params = {
							'qproxy_url': url
						};
					}
					if (source) {
						baseConfig.headers = {
							'Requested-By': source
						};
					}

					window.jQuery.extend(true, config, baseConfig);
					return $http(config);
				};

				return factory;

			})();
		}
	]);
})(angular.module('ripsaw'));

(function(module) {
	'use strict';
	module.constant('publishingConstants', {
		PARAMETER: 'publish-version',
		UNPUBLISHED: 'unpublished',
		PUBLISHED: 'published'
	});
})(angular.module('ripsaw'));

(function(module) {
	'use strict';

	module.factory('_rsRegistry', [
		'$q',
		'$http',
		'$templateCache',
		'$window',
		'rsMessages',
		'_rsResourceCache',
		'rsEnvironment',
		'rsConfig',
		'routeTypes',
		function($q, $http, $templateCache, $window, messages, resourceCache, environment, rsConfig, routeTypes)
		{
			var LOAD_ALL_META_DATA = 'load-all-meta';
			var LOAD_META_DATA_BY_WIDGET = 'load-meta-by-widget';
			var REGISTRY_WIDGET_TAG_OR_DELIMITER = '~';

			var config = {
				cache: true
			};

			var widgets = resourceCache.widgets;
			var dependencies = resourceCache.dependencies;
			var widgetLoadStrategy;

			var service = {
				LOAD_ALL_META_DATA: LOAD_ALL_META_DATA,
				LOAD_META_DATA_BY_WIDGET: LOAD_META_DATA_BY_WIDGET,
				setStrategy: function (strategy) {
					if (strategy === LOAD_ALL_META_DATA || strategy === LOAD_META_DATA_BY_WIDGET) {
						widgetLoadStrategy = strategy;
						if (strategy === LOAD_ALL_META_DATA) {
							getMetaData(); // warm the cache
						}
						return true;
					}
					window.console && console.error && console.error('rsRegistry: invalid load meta data strategy');
					return false;
				},


				ensureWidget: function(type) {
					type = type.replace('.', '/').replace(/\/$/, '');

					if(!widgets[type]) {
						loadWidget(type);
						return widgets[type];
					} else {
						return widgets[type].then(
							function success(){
								return widgets[type];
							},
							function error(){
								return loadWidget(type);
							});
					}

				},
				ensureDependency: function(type)
				{
					return ensureDependency(type);
				},
				resolveDependency: function(type) {
					dependencies[type] = $q.when();
				},
				getWidgets: function(tags) {
					return $http.get(getResourceMetaListUrl('widgets', tags), config)
						.then(getResultSuccess);
				},
				getResourceUrl: function(meta, resource) {
					return getResourceUrl('widget', meta, resource);
				}
			};

			function getBaseUrl() {
				return rsConfig.getRoute(routeTypes.REGISTRY);
			}

			// type should be 'widgets' or 'dependencies'
			function getResourceMetaListUrl(type, tags) {
				return _buildResourceMetaUrl(type, tags, null);
			}

			function getResourceMetaUrl(type, name) {
				return _buildResourceMetaUrl(type, null, name);
			}

			function _buildResourceMetaUrl(type, opt_tags, opt_name) {
				var bundle = environment.get('componentBundle');
				var path = [type];
				var query = [];

				if (bundle && bundle.name && bundle.version) {
					path = ['bundles', bundle.name, bundle.version, 'resources'].concat(path);
					var fallback = (bundle.fallback !== undefined ? bundle.fallback : true);
					if(opt_name) {
						query.push('fallbackActive=' + fallback);
					}
					else {
						query.push('includeActive=' + fallback);
					}
				}
				if (opt_name) {
					path.push(opt_name);
				}
				if (opt_tags) {
					query.push('tags=' + opt_tags.join(REGISTRY_WIDGET_TAG_OR_DELIMITER));
				}

				var url = getBaseUrl() + '/' + path.join('/');
				if(query.length > 0) {
					url += '?' + query.join('&');
				}
				return url;
			}
			function loadWidget(type) {
				widgets[type] = getWidget(type)
					.then(function (meta) {
						$http.get(getResourceUrl('widget', meta, 'resources.json'), config);
						return ensureDependencies(meta);
					})
				.then(loadWidgetResources);
				return widgets[type];
			}
			function getResourceUrl(type, meta, resource) {
				var path = (type === 'widget' ? '/widgets/' : '/dependencies/');
				return getBaseUrl() + path + meta.author + '/' + meta.name + '/v' + (meta._version || meta.version || 0) + '/' + resource;
			}
			function loadMetaData() {
				var
					widgets = $http.get(getResourceMetaListUrl('widgets', null), config).then(getResultSuccess),
					depen = $http.get(getResourceMetaListUrl('dependencies', null), config).then(getResultSuccess);
				getMetaDataCache = $q.all({ widgets: widgets, depen: depen}).then(function (data) {
						var ret = {widgets: {}, dependencies: {}};
						_.forEach(data.widgets, function (widget) {
							ret.widgets[widget.author + '/' + widget.name] = widget;
						});
						_.forEach(data.depen, function (depen) {
							ret.dependencies[depen.author + '/' + depen.name] = depen;
						});
						return ret;
					});
				return getMetaDataCache;
			}
			var getMetaDataCache;
			function getMetaData() {
				if (!getMetaDataCache) {
					loadMetaData();
					return getMetaDataCache;
				} else {
					return getMetaDataCache.then(
						function success(){
							return getMetaDataCache;
						},
						function error(){
							return loadMetaData();
						});

				}
			}

			function getWidget(type) {
				if (widgetLoadStrategy === LOAD_META_DATA_BY_WIDGET) {
					return $http.get(getResourceMetaUrl('widgets', type), config)
						.then(getResultSuccess);
				} else {
					return getMetaData().then(function (data) {
						if(!data.widgets[type]) {
							throw new Error('Metadata for widget "' + type + '" not found. ' +
									'If you are using bundles with fallback disabled, ' +
									'make sure this widget is specified in the bundle.');
						}
						return data.widgets[type];
					});
				}
			}

			function getDependency(type) {
				if (widgetLoadStrategy === LOAD_META_DATA_BY_WIDGET) {
					return $http.get(getResourceMetaUrl('dependencies', type), config)
						.then(getResultSuccess);
				} else {
					return getMetaData().then(function (data) {
						if(!data.dependencies[type]) {
							throw new Error('Metadata for dependency "' + type + '" not found. ' +
									'If you are using bundles with fallback disabled, ' +
									'make sure this dependency is specified in the bundle.');
						}
						return data.dependencies[type];
					});
				}
			}

			function ensureDependency(type) {
				type = type.replace('dependencies/', '').replace('.', '/').replace(/\/$/, '');

				if(!dependencies[type]) {
					dependencies[type] = getDependency(type)
						.then(function (meta) {
							// start fetching code - warm cache
							$http.get(getResourceUrl('dependency', meta, 'resources.json'), config);
							return ensureDependencies(meta);
						})
						.then(loadDependencyResources);
				}
				return dependencies[type];
			}

			function ensureDependencies(meta) {
				var promises = [];

				angular.forEach((meta.dependencies || []), function(dependency) {
					promises.push(ensureDependency(dependency));
				});

				return $q.all(promises).then(function() {
					return meta;
				});
			}

			function loadWidgetResources(meta) {

				return loadResources('widget', meta);
			}

			function loadDependencyResources(meta) {

				return loadResources('dependency', meta);
			}

			function loadResources(type, meta) {

				var promise = $http.get(getResourceUrl(type, meta, 'resources.json'), config).then(getResultSuccess);

				return promise.then(function(resources)
				{
					if (resources.js) {

						var script = document.createElement('script');
						script.type = 'text/javascript';
						script.text = resources.js;

						//TODO: proper error handling. Can't use try catch since the script runs asynchronously
						// it doesn't return promise either so can't catch the result
						window.jQuery('head').append(script);
					}

					if (resources.css) {
						// We tack on an empty comment to close off a comment from mis-compiled widgets @see RW-4155
						resources.css += '/* */';

						var style = window.jQuery('<style id="' + meta.author + '-' + meta.name + '-css">' + resources.css + '</style>');
						window.jQuery('head').append(style);
					}
					if (resources.templates) {
						var templates = resources.templates;
						for(var t in templates) {
							if (templates.hasOwnProperty(t))
							{
								var templatePath = meta.author + '/' + meta.name + '/templates/' + t;
								$templateCache.put(templatePath, templates[t]);
							}
						}
					}

					if (resources.lang) {
						messages.addMessages(resources.lang);
					}

					return meta;
				});
			}

			function getResultSuccess(result) {
				return result.data;
			}

			return service;
		}
	]);
})(angular.module('ripsaw'));

(function(app){
	'use strict';

	app.factory('requestAggregator',
	[
		'$http',
		'$q',
		'$timeout',
		'rsEnvironment',
		'uuid',
		function($http, $q, $timeout, environment, uuid)
		{
			var aggregators = {};
			var privates = {};
			var deferSet = {};

			var addRequest = function(aggregator, config){
				var requestId = uuid.generate();
				var deferred = $q.defer();

				deferSet[requestId] = deferred;
				var hidden = privates[aggregator.id];
				if(config.params){
					config.url += '?' + Object.keys(config.params).map(function(key){
						return encodeURIComponent(key) + '=' + encodeURIComponent(config.params[key].toString());
					}).join('&');
				}
				hidden.requests[requestId] = {
					url: config.url,
					method: config.method
				};
				if(config.body){
					hidden.requests[requestId].body = JSON.stringify(config.body);
				}
				if(++hidden.numRequests >= 10 || aggregator.timedOut || aggregator.finished){
					hidden.sendRequests();
				}
				return deferred.promise;
			};

			var Aggregator = function(config){
				// I know this isn't a perfect check for this being called with 'new', but it's the "most" reasonable one that works on IE8
				if(!this || this.constructor !== Aggregator){
					throw new Error('Must call constructor as `new`');
				}
				config = config || {};
				if(config.id && aggregators[config.id]){
					return aggregators[config.id];
				}
				this.timeout = config.timeout !== undefined ? config.timeout : 5000;
				this.id = config.id || uuid.generate();
				this.finished = false;

				var hidden = privates[this.id] = {};
				hidden.url = config.url || environment.get('aggregationUrl') || '/aggregate';
				hidden.numRequests = 0;
				hidden.requests = {};

				hidden.sendRequests = function(){
					if(hidden.numRequests === 0){
						return;
					}
					var fired = hidden.requests;
					hidden.numRequests = 0;
					hidden.requests = {};
					$http.post(hidden.url, fired).then(function(res){
						Object.keys(res.data).forEach(function(key){
							var data = res.data[key];
							data.config.url = hidden.url + fired[key].url;
							if(data.data && data.data !== ''){
								data.data = JSON.parse(data.data);
							}
							if(data.status >= 400){
								// TODO: This should throw an error, not an object
								deferSet[key].reject(data);
							} else{
								deferSet[key].resolve(data);
							}
						});
					});
				};

				aggregators[this.id] = this;
				var that = this;
				$timeout(function(){
					that.timedOut = true;
					hidden.sendRequests();
				}, this.timeout);
			};

			Aggregator.get = function(id){
				return aggregators[id] || new Aggregator({
					id: id
				});
			};

			// Logic for whether or not to use the Aggregator can be stored on the aggregator class itself
			Aggregator.getHttp = function(param){
				if(!param){
					return $http;
				}

				if(typeof param === 'string'){
					return Aggregator.get(param);
				} else if(param instanceof Aggregator){
					return param;
				} else{
					return $http;
				}
			};

			Aggregator.prototype.get = function(url, config){
				var configs = config || {};
				configs.method = 'GET';
				configs.url = url;

				return addRequest(this, configs);
			};

			Aggregator.prototype.post = function(url, body, config){
				var configs = config || {};
				configs.method = 'POST';
				configs.url = url;
				configs.body = body;

				return addRequest(this, configs);
			};

			Aggregator.prototype.del = function(url, config){
				var configs = config || {};
				configs.method = 'DELETE';
				configs.url = url;

				return addRequest(this, configs);
			};

			Aggregator.prototype.put = function(url, body, config){
				var configs = config || {};
				configs.method = 'PUT';
				configs.url = url;
				configs.body = body;

				return addRequest(this, configs);
			};

			Aggregator.prototype.finish = function(){
				privates[this.id].sendRequests();
				this.finished = true;
			};

			return Aggregator;
		}
	]);
})(angular.module('ripsaw'));

(function (module) {
	'use strict';

	module.constant('routeTypes', Object.freeze({
		BENCHMARKS: 'benchmarks',
		CONTAINERS: 'containers',
		FIELDSETS: 'fieldsets',
		FIELDSET_DEFINITION: 'fieldset_definition',
		PERMISSIONS: 'permissions',
		PROGRESS: 'progress',
		PROXY: 'proxy',
		REGISTRY: 'registry',
		RESPONSES: 'responses',
		RIPSAW_SERVER_SURVEYS: 'ripsaw_server_surveys',
		SURVEYS: 'surveys'
	}));
})(angular.module('ripsaw'));

(function(module) {
	'use strict';

	module.factory('_rsSnapshotUtil', [
		'rsEnvironment',
		function(env) {
			return {
				isSnapshot: isSnapshot,
				snapshotHasOwnFieldset: function(currentFieldsetId) {
					var containerFieldsetId = env.get('containerFieldsetId');
					return currentFieldsetId !== containerFieldsetId;
				}
			};

			function isSnapshot() {
				return !!(env.get('containerSnapshotEnabled') && env.get('containerSnapshotId'));
			}
		}
	]);
})(angular.module('ripsaw'));

(function(module) {
    'use strict';

    module.factory('_rsTimezoneUtil', [
        'rsEnvironment',
        function(env) {

            return {
                getTimezoneDiff: function() {
                    var timezone = env.get('timezone');
                    // Really really hacky way to produce DST unaware diff. There are several weird issues happen otherwise
                    return timezone ? moment.tz('2010-01-01', timezone).format('Z') : null;
                },

                getTimezone: function() {
                    var timezone = env.get('timezone');
                    if (!timezone) {
                        timezone = 'GMT';
                    }
                    return timezone;
                },

                /**
                 * Returns passed time shifted to the timezone set in environment
                 */
                dateInTimezone: function(dateString) {
                    return moment.tz(dateString, this.getTimezone());
                },

                /**
                 * Shifts the date-time to beginning of the day (12am) and returns as a Moment object
                 *
                 * @param {string} dateString ISO-8601 formatted date string or other format that Moment can parse
                 * @returns {Moment} Time shifted to starting of the day in the environment timezone
                 */
                midnightInTimezone: function(dateString) {
                    var timezone = this.getTimezone();
                    return moment.tz(dateString, timezone).startOf('day');
                },

                /**
                 * Format the date in ISO-8601 format. Output is not DST aware.
                 */
                formatDate: function(momentObj) {
                    var dateString = momentObj.format();
                    var timezoneDiff = this.getTimezoneDiff();
                    if (timezoneDiff) {
                        // Replace DST timeshift with non-DST timeshift
                        dateString = dateString.replace(/(\+|\-)[\d]{2}:[\d]{2}/, timezoneDiff);
                    }
                    dateString = dateString.replace('+00:00', 'Z');
                    return dateString;
                }
            };
        }
    ]);
})(angular.module('ripsaw'));
(function(module) {
	'use strict';
	module.factory('_rsTranslations', [
		'rsEnvironment',
		function(env) {

			function getTranslationConfig() {
				var config = {
					headers: {
						// provide function so that environment variable is defined on run time eval
						'Content-Language': function () {
							var isDynamicTranslationsEnabled = env.get('dynamicTranslations');

							if (isDynamicTranslationsEnabled) {
								var language = env.get('user', 'language');
								if (language) {
									return language;
								}
							}
							return null;
						}
					}
				};
				return config;
			}

			return {
				getTranslationConfig: getTranslationConfig
			};
		}
	]);
})(angular.module('ripsaw'));

(function() {
	'use strict';

	angular.module('ripsaw').factory('uuid',
	[
		function()
		{
			return {
				// Copied from ng-uuid https://github.com/jspaper/ng-uuid
				generate: function() {
					function _p8(s) {
						var p = (Math.random().toString(16) + '000000000').substr(2, 8);
						return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
					}
					return _p8() + _p8(!0) + _p8(!0) + _p8();
				}
			};
		}
	]);
})();
(function(module) {
	'use strict';

	module.factory('_rsWidgetsMetadata', [
		function() {
			var mobileFriendlyWidgetTypes = [
				'reporting.simplechart',
				'reporting.pie',
				'reporting.star',
				'reporting.breakdownbar',
				'reporting.gauge',
				'reporting.number',
				'reporting.simpletable',
				'reporting.recordgrid',
				'reporting.keydrivers',
				'reporting.image',
				'reporting.richtext',
				'reporting.wordcloud',
				'reporting.voiceletticker',
				'reporting.prescriptiveinsights',
				'reporting.strategicaccounts',
				'reporting.rsdknumberchart',
				'reporting.rsdkgauge',
				'reporting.rsdkjourney',
				'reporting.rsdkwidget',
				'reporting.aggregatetable',
				'employeeinsights.actionplanningeditor',
				'employeeinsights.highlow',
				'employeeinsights.participationsummary',
				'employeeinsights.engagementsummary',
				'employeeinsights.scorecard',
				'employeeinsights.heatmap',
				'eng.funnel',
				'eng.correspondenceanalysis',
				'profserv.simplechartafklm',
				'profserv.marriottfilteroverrider',
				'profserv.responserates360',
				'cx.agentperformancewidget',
				'cx.coachingprioritieswidget',
				'cx.mirroredfeedbackinteractionswidget',
				'cxapp.strategicaccounts',
				'textanalytics.bubble',
				'cxintelligence.textiqhierarchy',
				'cxintelligence.rsdkfocusareas',
				'cxintelligence.keydriveranalysis'
			];

			var service = {
				getWidgetsMetaData: function(widgetTypes) {
					var metaData = [];

					widgetTypes.forEach(function(widgetType) {
						metaData[widgetType] = {
							mobileFriendly: isMobileFriendlyWidgetType(widgetType) ? true : false
						};
					});

					return metaData;
				}
			};

			function isMobileFriendlyWidgetType(widgetType) {
				return mobileFriendlyWidgetTypes.includes(widgetType);
			}

			return service;
		}
	]);
})(angular.module('ripsaw'));
